import Slider from "react-slick";
import axios from "axios";
import { toast } from "react-toastify";
import { getUsdToGbp } from "../../utils/fxRate";
import { buildCategoryPath } from "../../utils/categoryUrl";
import { applyRetailerPricing } from "../../utils/vatHelper";
import {
  PICTURE_ENAMELLING_INTRO,
  PICTURE_ENAMELLING_LABEL,
  PICTURE_ENAMELLING_POINTS,
} from "../../utils/pictureEnamelling";
import { useEffect, useState, useCallback, useRef, useMemo } from "react";
import { createPortal } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Tabs,
  Collapse,
  Select,
  Modal,
  Image,
  Breadcrumb,
} from "antd";
import { useLocation, useNavigate, Link, useParams } from "react-router-dom";
import { slugify } from "../../utils/categoryUrl";
import { getProductIdApi } from "../../Features/Product/Product";
import { routes } from "../../Routes/Routes";
import Description from "../Description/Description";
import EngagementCentreStone from "./EngagementCentreStone";
import EngagementBuilder from "./EngagementBuilder";
import Preloader360 from "./Preloader360";
import { addCartApi } from "../../Features/AddCart/AddCart";
import { getProductReviewApi } from "../../Features/Setting/Setting";
import { addWishList, getWishListApi } from "../../Features/WishList/WishList";
import { apiCall } from "../../Services/CommonService";

import styles from "./index.module.scss";
import { ProductCard } from "../../Component/productCard";
import ProductPageLoader from "../../Component/ProductPageLoader/ProductPageLoader";
import { BASE_URL, apiUrl } from "../../Constant";

import {
  HeartOutlined,
  HeartFilled,
  ShoppingCartOutlined,
} from "@ant-design/icons";
import RingSizeChartModal from "../../Component/RingSizeChartModal/RingSizeChartModal";
import { sampleImageCaption, captionSourceFor, modelForWidth } from "../../utils/sampleImageCaption";
import { mentionsRing, offersFingerSize } from "../../utils/ringSize";

// 360 viewer toolbar (close / fullscreen / orbit / share) — circular icon button.
const TB360 = { width: 34, height: 34, borderRadius: "50%", border: "none", background: "rgba(17,17,17,0.7)", color: "#fff", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", padding: 0, lineHeight: 1 };
const TB360_GOLD = "#C5A028";

// WebGL availability — probed once per session. The Render 360 embed needs
// WebGL; without it we keep the photo gallery instead of auto-opening a blank
// viewer.
let _webglOk = null;
const webglSupported = () => {
  if (_webglOk !== null) return _webglOk;
  try {
    const c = document.createElement("canvas");
    _webglOk = !!(c.getContext("webgl2") || c.getContext("webgl") || c.getContext("experimental-webgl"));
  } catch {
    _webglOk = false;
  }
  return _webglOk;
};

// Low-end heuristic — when true we pass ?lowmem=1 to the embed (it renders at
// CSS 1.0× and strips post-processing) so the 360 stays stable on weak/
// memory-constrained or data-saver devices. Thresholds are conservative; tune
// here if needed. deviceMemory is absent on Safari/iOS, so cores carry it there.
const isLowEndDevice = () => {
  if (typeof navigator === "undefined") return false;
  const nav = navigator;
  if (nav.connection && nav.connection.saveData) return true;
  if (typeof nav.deviceMemory === "number" && nav.deviceMemory <= 4) return true;
  if (typeof nav.hardwareConcurrency === "number" && nav.hardwareConcurrency <= 4) return true;
  return false;
};
const IconFullscreen = () => (<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M8 3H5a2 2 0 0 0-2 2v3M21 8V5a2 2 0 0 0-2-2h-3M3 16v3a2 2 0 0 0 2 2h3M16 21h3a2 2 0 0 0 2-2v-3" /></svg>);
const IconOrbit = () => (<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M23 4v6h-6" /><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" /></svg>);
const IconShare = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="18" cy="5" r="3" /><circle cx="6" cy="12" r="3" /><circle cx="18" cy="19" r="3" /><line x1="8.59" y1="13.51" x2="15.42" y2="17.49" /><line x1="15.41" y1="6.51" x2="8.59" y2="10.49" /></svg>);

const CustomiseIcon = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    width="16"
    height="16"
    style={{ display: "inline-block", verticalAlign: "-3px", marginRight: 8 }}
    {...props}
  >
    <path d="M12 20h9" />
    <path d="M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
    <path d="M3 10l1.2-1.2M9 4l-1.2 1.2M3 16l1.2-1.2" />
  </svg>
);

function AddCart() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const { name } = useParams();

  const userID = useSelector((state) => state.user?.userId);
  const userToken = useSelector((state) => state.user?.token);
  const likeCounter = useSelector((state) => state.user?.likeCount);

  const productIdData = useSelector((state) => state.product?.productIdData);
  const productLoading = useSelector((state) => state.product?.productLoading);

  const loader = useSelector((state) => state.addCart?.isAddCartLoad);
  const likeProductList = useSelector(
    (state) => state.product?.productFeatureListLike,
  );

  const [variationData, setVariationData] = useState();
  const [variationSizes, setVariationSizes] = useState([]);

  const [isLiked, setIsLiked] = useState(false);
  const [hightLight, setHighLight] = useState(0);

  const [imgArr, setImgArr] = useState([]);
  const [singleImg, setSingleImg] = useState("");

  const [variationId, setVariationId] = useState("");

  const [sizeName, setSizeName] = useState();
  const [qty, setQty] = useState(1);
  // The customer's colour pick survives a metal-type change (see
  // handleOnClickVariation). Colour is a gold-only choice, so it reads as none
  // while Platinum/Silver is selected — everything that uses the colour (cart,
  // enquiry, quote, 360) goes through selectedColor, never the raw pick.
  const [pickedColor, setPickedColor] = useState(null);
  const selectedColor = /(platinum|silver)/i.test(variationData?.variationName || "") ? null : pickedColor;

  const [selectedQuality, setSelectedQuality] = useState("");
  // Declared HERE, not with the other build state further down, because the 360 effects
  // below resolve which model to show from the chosen width — and a const referenced
  // during render before its declaration hits the temporal dead zone and blanks the
  // page (the same trap the scroll-lock effect below documents).
  const [engagementSel, setEngagementSel] = useState(null); // halo build: { metalKey, sizeIndex, metalColour, carat, colour, clarity, quality }

  // The width the customer is currently configuring, as a LABEL off the recipe.
  const selectedWidthLabel = useMemo(() => {
    const ws = productIdData?.engagement?.widths || [];
    return ws[engagementSel?.widthIndex ?? 0]?.label || "";
  }, [productIdData?.engagement?.widths, engagementSel?.widthIndex]);

  // A piece offered in several widths can carry a 3D model for each, so the viewer shows
  // the one the customer actually picked. Falls back to an untagged model, then to the
  // legacy single model3d — so every product that predates this keeps its viewer.
  const activeModel = useMemo(
    () => modelForWidth(productIdData, selectedWidthLabel),
    [productIdData, selectedWidthLabel]
  );
  const activeEmbedId = activeModel?.embedId || "";

  const [show360, setShow360] = useState(false); // fullscreen Render 360 viewer
  // Desktop only: once the 360 has opened we keep its iframe MOUNTED and just
  // toggle visibility via show360 — so switching to a photo and back doesn't
  // reload the model from scratch. Mobile still mounts/unmounts + releases the
  // WebGL context on close (the iOS "second open crashes" safety).
  const [desktop360Mounted, setDesktop360Mounted] = useState(false);
  const [viewerReady, setViewerReady] = useState(false); // 360 pre-loader gate
  const iframe360Ref = useRef(null); // desktop 360 iframe — postMessage the metal colour
  const mobileIframe360Ref = useRef(null); // mobile 360 iframe (portal)
  const auto360EmbedRef = useRef(null); // auto-open the 360 once per product (keyed by embed id)
  const [show360Hint, setShow360Hint] = useState(false); // fading "drag to rotate" hint, shown once the render is visible
  const [imgPreviewOpen, setImgPreviewOpen] = useState(false); // AntD image-preview lightbox open?
  const [previewIndex, setPreviewIndex] = useState(0); // which image the lightbox shows (prev/next cycling)
  const desktop360ContainerRef = useRef(null); // desktop 360 wrapper — target for browser fullscreen
  const [orbit360, setOrbit360] = useState(false); // auto-orbit toggle
  // Keep the TDC pre-loader up until the Render embed posts "tdr-embed-ready"
  // (model fully loaded — the embed only posts this once the model has real
  // bounds AND a few frames have painted, so the diamond-shader compile +
  // GPU upload happen UNDER this loader, not over a blank canvas).
  //
  // If "ready" never arrives within the timeout the 360 almost certainly
  // failed to render (WebGL crash / load error), so we DROP BACK to the photo
  // gallery instead of revealing a blank viewer. The 30s ceiling sits above
  // the embed's own ~25s reveal so a slow-but-working load still wins (its
  // "ready" clears the timer); only a genuine no-show falls back. Manual retry
  // via the 360 button still works.
  // Runs once per LOAD of the embed, not per show/hide. Keyed on `embedActive`
  // (iframe mounted on desktop, or shown on mobile). On desktop the iframe persists
  // while a photo is shown, so this must NOT re-fire on a show toggle — otherwise it
  // would reset the pre-loader and re-arm the fail-timer that the embed (which posts
  // "ready" only once) can no longer clear, auto-closing a perfectly good viewer.
  const embedActive = desktop360Mounted || show360;
  useEffect(() => {
    if (!embedActive) return undefined;
    setViewerReady(false);
    setOrbit360(false); // reset auto-orbit on each load
    const onMsg = (e) => {
      if (typeof e.origin !== "string" || !e.origin.includes("thediamondrender")) return;
      if (e.data?.type === "tdr-embed-ready") { setViewerReady(true); clearTimeout(failTimer); }
      else if (e.data?.type === "tdr-orbit-stopped") setOrbit360(false); // a user grab stopped the orbit
    };
    window.addEventListener("message", onMsg);
    const failTimer = setTimeout(() => {
      auto360EmbedRef.current = activeEmbedId || auto360EmbedRef.current; // don't auto-reopen
      setShow360(false);
      setDesktop360Mounted(false); // genuine no-show → unmount so a manual retry reloads fresh
    }, 30000);
    return () => {
      window.removeEventListener("message", onMsg);
      clearTimeout(failTimer);
    };
  }, [embedActive, activeEmbedId]);
  // Lock page scroll behind full-screen overlays so the underlying page can't
  // scroll while one is open: the AntD image-preview lightbox (desktop + mobile)
  // and the MOBILE 360 takeover (a fixed full-viewport portal). The DESKTOP 360
  // is inline (it auto-opens and replaces the hero in normal flow), so it is
  // deliberately NOT locked — the customer still needs to scroll to price/CTA.
  // position:fixed + top offset is used (not just overflow:hidden) because iOS
  // Safari ignores overflow:hidden on body; the scroll position is captured and
  // restored on unlock so the page doesn't jump.
  useEffect(() => {
    // Computed inside the effect (not in render) because isMobileDevice is a
    // const declared later in the component — referencing it during render
    // would hit the temporal dead zone and blank the page.
    const lockScroll = imgPreviewOpen || (show360 && isMobileDevice());
    if (!lockScroll) return undefined;
    const scrollY = window.scrollY;
    const body = document.body;
    const prev = { overflow: body.style.overflow, position: body.style.position, top: body.style.top, width: body.style.width };
    body.style.overflow = "hidden";
    body.style.position = "fixed";
    body.style.top = `-${scrollY}px`;
    body.style.width = "100%";
    return () => {
      body.style.overflow = prev.overflow;
      body.style.position = prev.position;
      body.style.top = prev.top;
      body.style.width = prev.width;
      window.scrollTo(0, scrollY);
    };
  }, [imgPreviewOpen, show360]);
  const [selectedCentreStone, setSelectedCentreStone] = useState(null); // { carat, label }
  // Declared up here, not beside its fetch below, because the cost-breakdown
  // effect reads it in a dependency array that runs earlier in the render.
  const [cheapestCentre, setCheapestCentre] = useState(null);
  const [cheapestCentreStone, setCheapestCentreStone] = useState(null); // cheapest configured lab stone (the "from" price)
  const [engravingText, setEngravingText] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [finalPrice, setFinalPrice] = useState(0);
  // The chain is an ADD-ON, and "" — no chain — is where the page starts. Adnan, 2026-09-01:
  // "set this as default not the 17\" chain we discussed earlier, so that the product page price
  // and the product detail page both show the same price." A card quotes the piece alone, so a
  // detail page that opened with a chain already in quoted a different number for the same
  // product. It no longer does.
  const [chainLength, setChainLength] = useState("");
  // Picture enamelling — opt-in, off on load, for the SAME reason the chain starts empty:
  // the product card quotes the piece alone, and a detail page that opened with the add-on
  // already ticked would quote a different number for the same product.
  const [enamelSelected, setEnamelSelected] = useState(false);
  const [showEnamelInfo, setShowEnamelInfo] = useState(false);
  const [engHasCentre, setEngHasCentre] = useState(false);
  const isHaloBuild = !!productIdData?.engagement?.enabled;

  /* ────────────────────────── CHAIN ──────────────────────────
   * A pendant is priced on its own gold; the chain is a separate pass-through line, so it is
   * added to the DISPLAYED price rather than folded into finalPrice. That keeps it outside
   * applyRetailerPricing — no trade discount, no cash markup, no £5 rounding — which is
   * exactly how the server prices it. Fold it into finalPrice instead and the two disagree.
   *
   * Every price comes from the server in productIdData.chain. Nothing is computed here: the
   * browser is handed a priced table for the metals THIS product is sold in, and picks from it.
   */
  const chainCfg = productIdData?.chain || null;

  // The metal the PENDANT is in. Plain products carry { metalType, purity } per component; a
  // halo build carries the flat key.
  const pendantMetalKey = (() => {
    if (isHaloBuild) return String(engagementSel?.metalKey || "").toLowerCase();
    const size = variationSizes?.find((s) => s.sizeLabel === sizeName) || variationSizes?.[0];
    const mc = size?.metal?.components?.[0];
    if (!mc) return "";
    return `${String(mc.metalType || "").trim().toLowerCase()}_${String(mc.purity || "").trim().toLowerCase()}`;
  })();

  // The metal the CHAIN is in — a different question. We stock chains in 18K and hang every
  // pendant on one, so the chain does not follow the pendant unless the server says it should
  // (matchPendantMetal). The server decides; the browser only reads what it was told.
  const chainMetalKey = (() => {
    if (!chainCfg) return "";
    if (chainCfg.matchPendantMetal) return pendantMetalKey;
    return String(chainCfg.defaultMetalKey || "").toLowerCase();
  })();

  // Name the chain's metal whenever it is NOT the pendant's. A customer buying a 9K pendant is
  // getting an 18K chain and has to be told so before they buy, not after.
  const chainMetalLabel = (() => {
    if (!chainMetalKey || chainMetalKey === pendantMetalKey) return "";
    const [type, purity] = chainMetalKey.split("_");
    const metal = type === "platinum" ? "Platinum" : type.charAt(0).toUpperCase() + type.slice(1);
    return type === "platinum" ? `${metal} ${purity}` : `${purity.toUpperCase()} ${metal}`;
  })();

  // Lengths on offer in THIS metal. A pendant sold in 9K and platinum can have different
  // lengths priced in each, so the dropdown is rebuilt per metal rather than shown once.
  const chainForMetal = (chainCfg && chainMetalKey && chainCfg.byMetal?.[chainMetalKey]) || null;
  const chainLengths = chainForMetal ? (chainCfg.lengths || []).filter((l) => chainForMetal[l]) : [];
  const chainAvailable = chainLengths.length > 0;
  const chainSelected = chainAvailable && chainLength ? chainForMetal[chainLength] || null : null;
  const chainPrice = Number(chainSelected?.gbp || 0);

  /* ─────────────────────── PICTURE ENAMELLING ───────────────────────
   * A colour photo printed on the piece and lacquered. A flat workshop charge, so it behaves
   * exactly like the chain: added to the DISPLAYED price, outside applyRetailerPricing, which
   * is how the server charges it too (backend/utils/enamelPricing.js).
   *
   * The £ is never written down here — it arrives on productIdData.pictureEnamelling, and is
   * null when the piece does not offer enamelling, so "not offered" can never render as free.
   */
  const enamelCfg = productIdData?.pictureEnamelling || null;
  const enamelAvailable = !!enamelCfg && Number(enamelCfg.gbp) > 0;
  const enamelPrice = enamelAvailable && enamelSelected ? Number(enamelCfg.gbp || 0) : 0;

  // Clear a selection that has stopped being offered, so a withdrawn service cannot keep
  // charging. Mirrors the chain's guard directly above.
  useEffect(() => {
    if (enamelSelected && !enamelAvailable) setEnamelSelected(false);
  }, [enamelAvailable, enamelSelected]);

  /** What the customer actually pays: the piece, adjusted for this retailer, plus the
   *  pass-through add-ons — the chain at supplier cost and the enamelling at its flat fee.
   *  Both sit OUTSIDE applyRetailerPricing on purpose: neither is discounted, marked up for
   *  cash, or swept into the £5 rounding, and the server prices them the same way. Every
   *  price on this page goes through here so none of them can disagree. */
  const withAddOns = (n) => Number(applyRetailerPricing(n) || 0) + chainPrice + enamelPrice;


  // Nothing is ever auto-added — the customer opts in. This only CLEARS a selection that has
  // stopped being available (a length withdrawn, or a metal change that leaves it unpriced),
  // because keeping a dead one would quietly drop the chain from the price with nothing on
  // screen to say why.
  useEffect(() => {
    if (!chainLength) return;
    if (chainForMetal?.[chainLength]) return;
    setChainLength("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chainMetalKey, chainLength, chainAvailable]);
  const engNoCentre = !!productIdData?.engagement?.noCentre; // band/eternity — no centre stone
  // Once the model has loaded AND the pre-loader has faded out (render visible),
  // cue the embed's intro tilt, then show the fading "drag to rotate" hint AFTER
  // the tilt has stopped. Applies to EVERY product with a 360 — `show360` only
  // opens when a `render_embed_id` exists. Anchored on viewerReady (not on open)
  // so neither plays behind the loader; the embed can't time this itself (it
  // doesn't know when our pre-loader fades), so we postMessage it the cue.
  useEffect(() => {
    if (!show360 || !viewerReady) { setShow360Hint(false); return undefined; }
    const REVEAL = 1200;   // 0.7s Preloader360 fade + 0.5s start delay after the render is visible
    const INTRO_MS = 1500; // must match ShareAppV2's intro DURATION
    // Per-product tilt toggle (model3d.tilt, set on the 3D-model tab). ON unless
    // explicitly false, so models saved before the toggle existed stay active.
    // When off, skip the tilt cue but still show the "drag to rotate" hint (a
    // touch sooner, since there's no tilt to wait out).
    const tiltOn = activeModel?.tilt !== false;
    const cue = tiltOn
      ? setTimeout(() => {
          [iframe360Ref.current, mobileIframe360Ref.current].forEach((f) => {
            try { f?.contentWindow?.postMessage({ type: "tdr-intro-spin" }, "https://thediamondrender.co.uk"); } catch (_) {}
          });
        }, REVEAL)
      : null;
    const pillAt = tiltOn ? REVEAL + INTRO_MS : REVEAL; // after the tilt stops, or sooner if no tilt
    const showPill = setTimeout(() => setShow360Hint(true), pillAt);
    const hidePill = setTimeout(() => setShow360Hint(false), pillAt + 4200);
    return () => { if (cue) clearTimeout(cue); clearTimeout(showPill); clearTimeout(hidePill); };
  }, [show360, viewerReady, activeModel?.tilt]);

  // Auto-open the 360 viewer on load (once per product, keyed by embed id) so the
  // customer lands on the interactive render. Clicking a thumbnail closes it back
  // to the still photo (see the gallery onClicks).
  useEffect(() => {
    const eid = activeEmbedId;
    // Desktop only — on mobile the 360 is a full-screen takeover (thumbnails hidden),
    // too intrusive to auto-open; mobile keeps the manual "360" button.
    if (eid && webglSupported() && !isMobileDevice() && auto360EmbedRef.current !== eid) {
      auto360EmbedRef.current = eid;
      setDesktop360Mounted(true);
      setShow360(true);
    }
  }, [activeEmbedId]);

  // ── 360 toolbar handlers ─────────────────────────────────────────────
  // Desktop browser fullscreen on the 360 wrapper (mobile is already fullscreen).
  const toggle360Fullscreen = () => {
    const el = desktop360ContainerRef.current;
    if (!el) return;
    try {
      if (document.fullscreenElement) (document.exitFullscreen || document.webkitExitFullscreen)?.call(document);
      else (el.requestFullscreen || el.webkitRequestFullscreen)?.call(el);
    } catch (_) {}
  };
  // Toggle the embed's slow auto-orbit.
  const toggle360Orbit = () => setOrbit360((prev) => !prev);
  // Close the 360 viewer, RELEASING the embed's WebGL context first. Blanking the
  // iframe src unloads the embed document (firing its pagehide → loseContext) so
  // the GPU memory is freed BEFORE React unmounts the iframe. Without this, mobile
  // browsers leak the removed iframe's context and re-opening the 360 crashes the
  // phone (the "second attempt crashes" bug). The brief delay lets the blank
  // navigation start before the element is removed.
  const close360 = () => {
    [iframe360Ref.current, mobileIframe360Ref.current].forEach((f) => {
      try { if (f) f.src = "about:blank"; } catch (_) {}
    });
    setTimeout(() => setShow360(false), 60);
  };
  // Push the orbit on/off to the active embed whenever it changes (effect, not in
  // the state updater — keeps the postMessage reliable and side-effect-free).
  useEffect(() => {
    if (!show360) return;
    [iframe360Ref.current, mobileIframe360Ref.current].forEach((f) => {
      try { f?.contentWindow?.postMessage({ type: "tdr-orbit", on: orbit360 }, "https://thediamondrender.co.uk"); } catch (_) {}
    });
  }, [orbit360, show360]);
  // Share the diamond RENDER (360 viewer) URL — not the product page.
  const copy360ShareLink = async () => {
    const eid = activeEmbedId;
    const url = eid ? `https://thediamondrender.co.uk/embed/${eid}?swatch=1` : window.location.href;
    try { await navigator.clipboard.writeText(url); toast.success("360 render link copied"); }
    catch (_) { toast.error("Couldn't copy the link"); }
  };

  const [usdToGbp, setUsdToGbp] = useState(null);
  const [resolvedProductId, setResolvedProductId] = useState(state?.productId || "");
  const [loaderFadeOut, setLoaderFadeOut] = useState(false);
  const [showContent, setShowContent] = useState(false);
  const [sameBrandProducts, setSameBrandProducts] = useState([]);
  /* Pieces that go WITH this one — the matching bracelet for a chain.
     Matched on the product name server-side, because the collection is only
     recorded there. `relatedHasSet` says whether any of them is a different
     item type, which decides what the section is called. */
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [relatedHasSet, setRelatedHasSet] = useState(false);
  const [sameCategoryProducts, setSameCategoryProducts] = useState([]);
  const [costBreakdown, setCostBreakdown] = useState(null);
  // Collapsed state persists across pages so the admin's preference sticks.
  const [breakdownOpen, setBreakdownOpen] = useState(() => {
    try { return localStorage.getItem("tdc_breakdown_open") !== "0"; } catch { return true; }
  });
  const toggleBreakdown = () => {
    setBreakdownOpen((o) => {
      const n = !o;
      try { localStorage.setItem("tdc_breakdown_open", n ? "1" : "0"); } catch {}
      return n;
    });
  };
  const breakdownAbort = useRef(null);
  const [showRingSizeModal, setShowRingSizeModal] = useState(false);
  const [showCustomiseModal, setShowCustomiseModal] = useState(false);
  const [customiseMessage, setCustomiseMessage] = useState("");
  const [customiseSending, setCustomiseSending] = useState(false);

  // Share-to-WhatsApp modal state
  const [showShareModal, setShowShareModal] = useState(false);
  const [shareCustomiseOpen, setShareCustomiseOpen] = useState(false);
  const [shareIncludePrice, setShareIncludePrice] = useState(true);
  const [shareMarkupMode, setShareMarkupMode] = useState("amount"); // "pct" | "amount"
  const [shareMarkupPct, setShareMarkupPct] = useState(0);
  const [shareMarkupAmount, setShareMarkupAmount] = useState(0);
  const [sharePlusVAT, setSharePlusVAT] = useState(false);
  const [shareIncludeSku, setShareIncludeSku] = useState(true);
  const [shareFieldToggles, setShareFieldToggles] = useState({});
  const [shareSending, setShareSending] = useState(false);

  const submitCustomisation = async () => {
    const trimmed = (customiseMessage || "").trim();
    if (!trimmed) {
      toast.error("Please describe what you'd like customised");
      return;
    }
    if (!userToken) {
      toast.error("Please log in to send a customisation request");
      return;
    }

    const variants = [];
    if (productIdData?.SKU_Code) variants.push({ label: "SKU", value: productIdData.SKU_Code });
    if (variationData?.variationName) variants.push({ label: "Metal Type", value: variationData.variationName });
    if (selectedColor?.color) variants.push({ label: "Colour", value: selectedColor.color });
    if (sizeName) variants.push({ label: "Size", value: sizeName });
    if (selectedQuality) {
      const qLabel = qualityColumns.find(q => q.key === selectedQuality)?.label || selectedQuality;
      variants.push({ label: "Quality", value: qLabel });
    }
    if (selectedCentreStone?.label) {
      variants.push({ label: "Centre Stone", value: selectedCentreStone.label });
    }
    variants.push({ label: "Quantity", value: String(qty) });

    setCustomiseSending(true);
    try {
      const { data } = await axios.post(
        `${BASE_URL}/product/customise`,
        {
          productId: resolvedProductId,
          productUrl: window.location.href,
          message: trimmed,
          variants,
        },
        { headers: { Authorization: userToken } }
      );
      if (data?.type === "success") {
        toast.success(data.message || "Your request has been sent");
        setShowCustomiseModal(false);
        setCustomiseMessage("");
      } else {
        toast.error(data?.message || "Couldn't send your request");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Couldn't send your request");
    } finally {
      setCustomiseSending(false);
    }
  };
  const getQualityTotals = useCallback((components = []) => {
    const totals = {};

    components.forEach((component) => {
      (component.qualityVariants || []).filter(q => q.active !== false).forEach((q) => {
        const key = (q.quality || "").toLowerCase().replace(/[^a-z0-9]+/g, "_");
        const price = Number(
          q.finalPrice ??
            (Number(q.mainDiamondPrice || 0) + Number(q.otherTypesPrice || 0)),
        );

        if (key && key !== "single") {
          totals[key] = (totals[key] || 0) + price;
        } else if (key === "single" || !key) {
          Object.keys(totals).forEach((k) => {
            totals[k] += price;
          });
        }
      });
    });

    return totals;
  }, []);

  const getSizeQualityTotals = useCallback(
    (size) => {
      const diamondComponents = size?.diamondSizes?.[0]?.diamondComponents || [];
      return getQualityTotals(diamondComponents);
    },
    [getQualityTotals],
  );

  useEffect(() => {
    getUsdToGbp().then(r => { if (r) setUsdToGbp(r); });
  }, []);

  useEffect(() => {
    if (state?.productId) {
      setResolvedProductId(state.productId);
      return;
    }

    if (!name) return;

    // URL segment is a slug (hyphens); turn hyphens back into spaces for the
    // search fallback below.
    const decodedName = decodeURIComponent(name).replace(/-/g, " ").trim();
    if (!decodedName) return;

    /*
      Ask the backend which product this slug is. It matches slugify(Product_Name)
      against the whole catalogue, so the answer is exact.

      This used to be done by searching for the de-slugified words and taking the
      best-looking hit, which was wrong twice over:

        - slugify() drops punctuation, so "Marquise Tennis Bracelet (5 Pointer)"
          never string-equals "marquise tennis bracelet 5 pointer" and the exact
          match missed. 154 of 228 live product names contain punctuation.
        - the search is capped at 100 hits ranked by relevance, and a product is
          not guaranteed to be in the results for its own name — "Juste un Clou
          bracelet, small model" was not.

      Whenever both missed, it fell through to products[0] and quietly opened
      somebody else's product: 153 of 228 URLs did, and the canonicalise effect
      below then rewrote the address bar to match, so there was nothing on screen
      to say the wrong thing had loaded.
    */
    const searchFallback = () => {
      const onSuccess = (response) => {
        const products = response?.products || [];
        // Compare with punctuation stripped from BOTH sides — the slug has
        // already lost it, so a literal compare can never match a name that has
        // any. Treat "&" and "and" alike, since a slug encodes "&" as "and".
        const norm = (s) =>
          String(s || "").toLowerCase().replace(/&/g, "and").replace(/[^a-z0-9]+/g, "");
        const target = norm(decodedName);
        const matched = products.find((item) => norm(item?.Product_Name) === target) || products[0];
        if (matched?._id) setResolvedProductId(matched._id);
      };

      apiCall(
        "GET",
        `${apiUrl.GET_SEARCH_PRODUCT}?query=${encodeURIComponent(decodedName)}&userId=${userID ? userID : 0}&limit=100`,
        "",
        onSuccess,
        () => {},
      );
    };

    const slug = decodeURIComponent(name).trim().toLowerCase();
    apiCall(
      "GET",
      `${apiUrl.RESOLVE_PRODUCT_SLUG}/${encodeURIComponent(slug)}`,
      "",
      (response) => {
        const id = response?.product?._id;
        if (id) setResolvedProductId(id);
        // A miss is answered with product:null, not an error — the slug is for a
        // piece that is no longer listed. Search anyway rather than showing
        // nothing; it is the older behaviour, and no worse than it ever was.
        else searchFallback();
      },
      searchFallback,
    );
  }, [name, state?.productId, userID]);

  useEffect(() => {
    if (!resolvedProductId) return;

    dispatch(getProductIdApi(resolvedProductId, userID ? userID : 0));
    dispatch(getProductReviewApi(resolvedProductId, userToken));
    window.scrollTo(0, 0);
  }, [dispatch, resolvedProductId, userID, userToken]);

  // Canonicalise the address bar to the loaded product's own slug, so the URL
  // can never show a different product than what's displayed (e.g. a link that
  // paired the wrong slug with this product's id, or a slug that fell back to
  // the first search result). Only acts once the displayed product IS the
  // resolved one; replace-only + keeps nav state so it triggers no re-fetch.
  useEffect(() => {
    if (!productIdData?._id || productIdData._id !== resolvedProductId) return;
    const correctSlug = slugify(productIdData.Product_Name || "");
    if (correctSlug && name !== correctSlug) {
      navigate(`/product-detail/${correctSlug}`, { replace: true, state });
    }
  }, [productIdData, resolvedProductId, name, navigate, state]);

  useEffect(() => {
    if (!productLoading && !showContent) {
      setLoaderFadeOut(true);
      const timer = setTimeout(() => {
        setShowContent(true);
      }, 600);
      return () => clearTimeout(timer);
    }
    if (productLoading) {
      setLoaderFadeOut(false);
      setShowContent(false);
    }
  }, [productLoading, showContent]);

  // Fetch related products by brand and category (API expects ObjectIds)
  useEffect(() => {
    if (!productIdData) return;
    const brand = productIdData?.Brand;
    const category = productIdData?.Category?.[0];
    const currentId = resolvedProductId;

    // Brand could be an object with _id, or a string ID itself
    const brandId = brand?._id || (typeof brand === "string" ? brand : null);
    const categoryId = category?._id || (typeof category === "string" ? category : null);

    // Related pieces. Keyed on the product itself rather than its brand or
    // category, so it runs for house-brand products too.
    if (currentId) {
      apiCall(
        "GET",
        `${BASE_URL}/product/related/${currentId}?limit=8`,
        "",
        (res) => {
          const items = Array.isArray(res?.product) ? res.product : [];
          setRelatedProducts(items);
          setRelatedHasSet(!!res?.hasSet);
        },
        () => {},
      );
    }

    if (brandId) {
      apiCall(
        "GET",
        `${apiUrl.GET_ALL_PRODUCT}?brand=${brandId}&limit=12`,
        "",
        (res) => {
          const data = res?.product_data || res?.product || res?.products || [];
          const items = (Array.isArray(data) ? data : []).filter((p) => p._id !== currentId);
          setSameBrandProducts(items.slice(0, 8));
        },
        () => {},
      );
    }

    if (categoryId) {
      apiCall(
        "GET",
        `${apiUrl.GET_ALL_PRODUCT}?category=${categoryId}&limit=12`,
        "",
        (res) => {
          const data = res?.product_data || res?.product || res?.products || [];
          const items = (Array.isArray(data) ? data : []).filter((p) => p._id !== currentId);
          setSameCategoryProducts(items.slice(0, 8));
        },
        () => {},
      );
    }
  }, [productIdData, resolvedProductId]);

  useEffect(() => {
    if (
      productIdData?.variation?.length === 0 ||
      productIdData?.variation?.[0]?.variation_Sizes?.length === 0
    )
      setQty(0);
    window.scrollTo(0, 0);
  }, [productIdData, getSizeQualityTotals]);

  const Incree = () => {
    setQty(qty + 1);
  };

  const Decree = () => {
    if (qty > 0) {
      setQty(qty - 1);
    }
  };

  const [selectedMetalSizeId, setSelectedMetalSizeId] = useState(null);
  const [selectedDiamondSizeId, setSelectedDiamondSizeId] = useState(null);

  // Silently fetch cost breakdown for privileged users.
  // Returns 403 for non-privileged — no UI indication either way.
  useEffect(() => {
    if (breakdownAbort.current) breakdownAbort.current.abort();
    if (!userToken || !resolvedProductId) { setCostBreakdown(null); return; }
    let url;
    if (isHaloBuild) {
      const s = engagementSel;
      // Band / eternity builds have NO centre stone, so there's no carat — only
      // gate on a centre carat for centre-stone builds. Bands still price off
      // metal + size + shank melee, so fetch the breakdown without a carat.
      if (!s || (!engNoCentre && !s.carat)) { setCostBreakdown(null); return; }
      const p = new URLSearchParams({ sizeIndex: String(s.sizeIndex ?? 0), widthIndex: String(s.widthIndex ?? 0), coverageIndex: String(s.coverageIndex ?? 0), metal: s.metalKey || "", quality: s.quality || "" });
      if (!engNoCentre && s.carat) {
        p.set("carat", String(s.carat));
        p.set("colour", s.colour || "");
        p.set("clarity", s.clarity || "");
      }
      url = `${BASE_URL}/product/cost-breakdown/${resolvedProductId}?${p.toString()}`;
    } else {
      // Always attempt the fetch for privileged viewers so the breakdown shows on
      // EVERY product — pass the selected size when we have one, otherwise the
      // backend defaults to the product's first metal size.
      const p = new URLSearchParams();
      if (selectedMetalSizeId) p.set("metalSizeId", selectedMetalSizeId);
      if (selectedQuality) p.set("quality", selectedQuality);
      // Send the chosen centre stone too, the way the halo branch above does.
      // Without it the backend only ever saw the product's melee, which these
      // pendants don't have — hence Diamond Cost £0.00 next to a 2ct diamond.
      const centre = selectedCentreStone || cheapestCentre;
      if (centre?.carat && centre?.colour && centre?.clarity) {
        p.set("carat", String(centre.carat));
        p.set("colour", centre.colour);
        p.set("clarity", centre.clarity);
      }
      const qs = p.toString();
      url = `${BASE_URL}/product/cost-breakdown/${resolvedProductId}${qs ? `?${qs}` : ""}`;
    }
    const ctrl = new AbortController();
    breakdownAbort.current = ctrl;
    fetch(url, { headers: { Authorization: userToken }, signal: ctrl.signal })
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        if (data?.type === "success" && data.breakdown) setCostBreakdown(data.breakdown);
        else setCostBreakdown(null);
      })
      .catch(() => {});
  }, [userToken, resolvedProductId, selectedMetalSizeId, selectedQuality, isHaloBuild, engagementSel, selectedCentreStone, cheapestCentre]);

  // ── Metal colour → 360 viewer (desktop) ──────────────────────────────
  // Desktop: the colour selector drives the Render 360 viewer's metal colour
  // live via postMessage, and the in-viewer swatch is hidden (?swatch=0) so the
  // TDC selector is the single control. Mobile shows the in-viewer swatch
  // (?swatch=1) and the user changes colour there. Fires on colour change and
  // once the embed is ready (viewerReady) to sync the initial colour.
  const selectedColourName = isHaloBuild ? engagementSel?.metalColour : selectedColor?.color;
  const has360Colours = isHaloBuild || ((productIdData?.Variation || []).flatMap((v) => v.colors || []).filter((c) => c?.active !== false).length > 0);
  // Platinum/Silver: no platinum/silver finish in the embed → load white gold
  // (closest match) as the STARTUP colour everywhere (?metal=white). Desktop hides
  // the in-viewer swatch (?swatch=0; the TDC selector is the control); mobile keeps
  // the swatch shown (?swatch=1) so the customer can still explore colours — it
  // just starts on white. embedMetalParam = the initial metal the embed loads with.
  const isWhiteOnlyMetal = /platinum|silver/.test(String((isHaloBuild ? engagementSel?.metalKey : variationData?.variationName) || "").toLowerCase());
  const embedMetalParam = isWhiteOnlyMetal ? "white" : (isHaloBuild ? "yellow" : "");
  // DESKTOP keeps ONE iframe mounted across metal switches (it only shows/hides),
  // so its `src` must NOT change after mount — rewriting an iframe src re-navigates
  // it = a full 360 reload. That was the "Platinum reloads the 360" bug: Platinum
  // has no embed finish so it maps to white, which only needs a live material swap
  // (the tdr-set-metal postMessage below), not a fresh load. So derive the desktop
  // src's metal from the DEFAULT variation (Variation[0] — the metal the page also
  // starts on, and which does NOT change when the customer switches metal) and keep
  // it fixed; every later change, incl. Platinum/Silver→white and back, is pushed
  // live via postMessage. (Mobile mounts a fresh iframe each open and can't change
  // metal while it's open, so it keeps using the live values above.)
  const desktopStartupName = String((isHaloBuild ? "" : productIdData?.Variation?.[0]?.variationName) || "").toLowerCase();
  const desktopWhiteOnly = /platinum|silver/.test(desktopStartupName);
  const desktopMetalParam = desktopWhiteOnly ? "white" : (isHaloBuild ? "yellow" : "");
  // Desktop keeps the iframe mounted (persist the loaded model); mobile mounts the
  // portal fresh each time. selectImage switches the hero photo and, on desktop,
  // just HIDES the viewer (no teardown) so re-opening is instant.
  const open360 = () => { if (!isMobileDevice()) setDesktop360Mounted(true); setShow360(true); };
  const selectImage = (path) => {
    setSingleImg(path);
    if (isMobileDevice()) close360();   // mobile: release the WebGL context (iOS safety)
    else setShow360(false);             // desktop: hide only; the iframe stays loaded
  };
  useEffect(() => {
    if (!show360 || !viewerReady || isMobileDevice()) return;
    const n = String(selectedColourName || "").toLowerCase();
    // Resolve the embed metal family from the selected colour first, then from the
    // metal TYPE (variation name / engagement metal key). Platinum/Silver have no
    // embed finish → white (closest match). Driving this as a LIVE material swap is
    // what lets the persistent desktop iframe change metal WITHOUT reloading — incl.
    // selecting Platinum (→white) and switching back to a gold type (the carried-over
    // or first colour, set on the metal-type click so nothing is left showing white).
    const metalType = String((isHaloBuild ? engagementSel?.metalKey : variationData?.variationName) || "").toLowerCase();
    const famOf = (s) => /platinum|silver/.test(s) ? "white"
      : /yellow/.test(s) ? "yellow"
      : /rose|red|pink/.test(s) ? "rose"
      : /white/.test(s) ? "white"
      : "";
    const fam = famOf(n) || famOf(metalType);
    if (!fam) return;
    try { iframe360Ref.current?.contentWindow?.postMessage({ type: "tdr-set-metal", metal: fam }, "https://thediamondrender.co.uk"); } catch (_) {}
  }, [selectedColourName, variationData?.variationName, engagementSel?.metalKey, show360, viewerReady]);

  const productCategory =
    productIdData?.Category?.[0]?.Category_Name ||
    productIdData?.Category?.[0]?.category_name ||
    "";

  const menuLevel1 = productIdData?.Menu_Level1 || "";
  const menuLevel2 = productIdData?.Menu_Level2 || "";
  const menuLevel3 = productIdData?.Menu_Level3 || "";
  // Branded products (anything other than The Diamond Counter own brand)
  // need the brand inserted into the breadcrumb between Home and the
  // menu levels — otherwise the brand step of the navigation path is
  // lost on the product detail page.
  const productBrandName = productIdData?.Brand?.Brand_Name || "";
  const isBrandedProduct =
    productBrandName &&
    !productBrandName.toLowerCase().includes("diamond counter") &&
    productBrandName.toLowerCase() !== "tdc";

  // "Earrings" contains "ring", so a plain substring test put a Ring Size
  // Conversion Chart on every stud and hoop. Four live categories trip it —
  // "diamond earrings", "stud diamond earrings", "hoop diamond earrings" and
  // "earring" — so strip the earring words before asking about rings.
  // mentionsRing lives in utils/ringSize.js, shared with the halo builder.
  const isRingProduct =
    (productIdData?.Category || []).some((cat) =>
      mentionsRing(cat?.Category_Name || cat?.category_name)
    ) || mentionsRing(productIdData?.Product_Name);

  // A pair of earrings has no size to pick. The catalogue still needs one row
  // to hang the weight and stones off, so it carries a placeholder — "Pair",
  // or "Default" on older entries. Offering that as a choice asks a question
  // with a single answer.
  //
  // Keyed on the DATA rather than the category on purpose: 71 of the 81 earring
  // products carry a single "Pair", but 7 have genuine sizes (hoop diameters)
  // and must keep the selector. The same rule correctly hides it for the
  // pendants and necklaces whose only size is "Default".
  //
  // The size is still chosen underneath — the first one is selected on load —
  // so Add to Cart, pricing and the saved order line are unaffected.
  //
  // A finger-size ladder is the second way there is nothing to ask: only a ring
  // has a finger size, so a stud or a bracelet carrying UK sizes is a data
  // slip, not a question (see utils/ringSize.js). No product on this path trips
  // it today — the one that did, SKU 45335, is on the halo builder — but the
  // ladder is seeded by the admin form and nothing upstream keeps it to rings.
  const PLACEHOLDER_SIZE_RX = /^(pair|default|one size|n\/?a|-|—)?$/i;
  const hasChoosableSize =
    !(
      (variationSizes?.length || 0) <= 1 &&
      PLACEHOLDER_SIZE_RX.test(String(variationSizes?.[0]?.sizeLabel ?? "").trim())
    ) && offersFingerSize(productIdData, (variationSizes || []).map((s) => s?.sizeLabel));

  const addCart = () => {
    if (!variationId) {
      toast.error("Please select variation");
      return;
    }

    if (!selectedMetalSizeId) {
      toast.error("Please select size");
      return;
    }

    const isGold = /\d+K/i.test(variationData?.variationName || "");
    if (isGold && variationData?.colors?.filter(c => c.active !== false)?.length > 0 && !selectedColor?.color) {
      toast.error("Please select color");
      return;
    }

    if (qty <= 0) {
      toast.error("Quantity must be greater than 0");
      return;
    }

    // Halo engagement build — no variation; carry the customer's recipe selection.
    if (isHaloBuild) {
      if (!engNoCentre && (!engHasCentre || !engagementSel?.carat)) { toast.error("Please choose your centre diamond"); return; }
      const haloObj = {
        product: resolvedProductId,
        quality: engagementSel.quality,
        color: engagementSel.metalColour,
        engagementMetalKey: engagementSel.metalKey,
        engagementSizeIndex: engagementSel.sizeIndex,
        engagementWidthIndex: engagementSel.widthIndex,
        engagementCoverageIndex: engagementSel.coverageIndex,
        Quantity: qty,
        engravingText: engravingText.trim() || "",
        // Only the CHOICE travels. The server re-prices it from the chain builder, so a stale
        // tab or a doctored request is repriced rather than honoured.
        chainOption: chainAvailable && chainLength ? { length: chainLength, metalKey: chainMetalKey } : { length: "", metalKey: "" },
        // Same rule: the choice only, never the price.
        pictureEnamelling: enamelAvailable && enamelSelected,
        ...(engNoCentre ? {} : { centreStoneOption: { carat: engagementSel.carat, colour: engagementSel.colour, clarity: engagementSel.clarity } }),
      };
      dispatch(addCartApi(haloObj, (res) => {
        if (res?.type === "success") { toast.success(res.message || "Added to cart successfully"); navigate("/cart"); }
        else { toast.error(res?.message || "Something went wrong"); }
      }, userToken));
      return;
    }

    // Validate centre stone if product has it
    const csCfg = productIdData?.centreStone;
    const csRequired = csCfg?.enabled && (csCfg?.source === "lab-feed" || (csCfg?.options?.length > 0));
    if (csRequired && !selectedCentreStone) {
      toast.error("Please choose your centre diamond");
      return;
    }

    const cartobj = {
      product: resolvedProductId,
      variation: variationId,
      metalSizeId: selectedMetalSizeId,
      diamondSizeId: selectedDiamondSizeId,
      quality: selectedQuality,
      color: selectedColor?.color,
      Quantity: qty,
      engravingText: engravingText.trim() || "",
      chainOption: chainAvailable && chainLength ? { length: chainLength, metalKey: chainMetalKey } : { length: "", metalKey: "" },
      // Same rule: the choice only, never the price.
      pictureEnamelling: enamelAvailable && enamelSelected,
      centreStoneOption: selectedCentreStone ? { type: selectedCentreStone.type || "lab", carat: selectedCentreStone.carat, colour: selectedCentreStone.colour, clarity: selectedCentreStone.clarity } : undefined,
    };

    const onSuccessCallback = (res) => {
      if (res?.type === "success") {
        toast.success(res.message || "Added to cart successfully");
        navigate("/cart");
      } else {
        toast.error(res?.message || "Something went wrong");
      }
    };

    dispatch(addCartApi(cartobj, onSuccessCallback, userToken));
  };

  const handleSize = (size) => {
    setSizeName(size.sizeLabel);
    setSelectedMetalSizeId(size?._id);

    const metalPrice = convertPrice(size);

    const totals = getSizeQualityTotals(size);
    const qualityKeys = Object.keys(totals);
    const defaultQualityKey = qualityKeys.find(k => totals[k] > 0) || qualityKeys[0];
    const newQuality = (selectedQuality && qualityKeys.includes(selectedQuality)) ? selectedQuality : defaultQualityKey;
    setSelectedQuality(newQuality);
    setSelectedDiamondSizeId(size?.diamondSizes?.[0]?._id || null);

    const csPrice = getCentreStonePrice(newQuality, selectedCentreStone);
    setFinalPrice(priceForSize(size, totals[newQuality] || 0, csPrice));
  };

  // What a centre stone adds to a price that was computed WITHOUT it.
  //
  // There is ONE markup — a single percentage on the landed cost of the whole
  // piece — applied by the backend inside calculateProductPrice. The per-size
  // prices this page receives were computed with no stone and cannot be
  // recomputed here, so the stone's contribution is expressed as a delta: its
  // cost plus its share of that one markup. Mirrors centreStoneDelta on the
  // server. The fixed making fee is not part of the base, so it plays no part.
  const centreStoneDelta = useCallback((centreGBP, charges) => {
    const pct = Number(charges?.profitPct || 0);
    const centre = Number(centreGBP || 0);
    if (centre <= 0) return 0;
    return Number((centre * (1 + (pct > 0 ? pct / 100 : 0))).toFixed(2));
  }, []);

  // Full recomputation from the raw parts, mirroring calculateProductPrice on the
  // server. Needed whenever a MIN PROFIT floor is set: a floor is not linear, so
  // the delta above cannot be right — the API's per-size price already applied
  // the floor to a base with NO centre stone, and no amount added afterwards can
  // undo that. With the raw metal, raw melee and the charges all present here,
  // the honest fix is to price it the same way the server would.
  const priceWithCharges = useCallback((rawMetal, rawMelee, charges, centreGBP) => {
    const labour = Number(charges?.labour || 0);
    const making = Number(charges?.making || 0);
    const makingPct = Number(charges?.makingPct || 0);
    const profit = Number(charges?.profit || 0);
    const profitPct = Number(charges?.profitPct || 0);
    const profitMin = Number(charges?.profitMin || 0);
    const baseCost = Number(rawMetal || 0) + Number(rawMelee || 0);
    const makingFromPct = makingPct > 0 ? baseCost * makingPct / 100 : 0;
    const landedCost = baseCost + labour + makingFromPct + Number(centreGBP || 0);
    const profitFromPct = profitPct > 0 ? landedCost * profitPct / 100 : 0;
    return Number((landedCost + making + Math.max(profitMin, profit + profitFromPct)).toFixed(2));
  }, []);

  // The displayed price for an ordinary product at a given size + quality.
  // Without a floor the API's pre-computed per-size price plus a delta is exact
  // and is kept (it is what every product has always used). With a floor, price
  // it from the raw parts instead.
  const priceForSize = useCallback((size, qualityTotal, centreGBP) => {
    const charges = size?.metalCharges;
    const centre = Number(centreGBP || 0);
    if (Number(charges?.profitMin || 0) > 0 && centre > 0) {
      const rawMetal = (size?.metal?.components || []).reduce((s2, c) => s2 + Number(c?.price || 0), 0);
      return priceWithCharges(rawMetal, qualityTotal, charges, centre);
    }
    return Number(size?.metal?.totalMetalPrice || 0) + Number(qualityTotal || 0) + centreStoneDelta(centre, charges);
  }, [centreStoneDelta, priceWithCharges]);

  // Get centre stone price for a given quality key and carat option
  const getCentreStonePrice = useCallback((qualityKey, csOption) => {
    if (!productIdData?.centreStone?.enabled) return 0;
    // Lab-feed: a selected stone uses its fetched price; with no selection yet,
    // fall back to the cheapest configured stone so the shown price includes a diamond.
    if (productIdData.centreStone.source === "lab-feed") {
      if (csOption?.totalGBP != null) return Number(csOption.totalGBP || 0);
      return Number(cheapestCentreStone?.totalGBP || 0);
    }
    if (!csOption) return 0;
    const opt = productIdData.centreStone.options?.find(o => Number(o.carat) === Number(csOption.carat));
    if (!opt) return 0;
    const normKey = (qualityKey || "").toLowerCase().replace(/[^a-z0-9]+/g, "_");
    // Check if this quality is active for this carat
    const overrides = opt.qualityOverrides || {};
    if (overrides[normKey] === false) return 0;
    const qv = opt.qualityVariants?.find(q => (q.quality || "").toLowerCase().replace(/[^a-z0-9]+/g, "_") === normKey);
    if (qv) return Number(qv.finalPrice || 0);
    // Fallback: single quality
    const single = opt.qualityVariants?.find(q => (q.quality || "").toLowerCase().replace(/[^a-z0-9]+/g, "_") === "single");
    return single ? Number(single.finalPrice || 0) : 0;
  }, [productIdData, cheapestCentreStone]);

  // Convert price from USD to GBP, separating metal cost (convert) from fixed charges (keep as-is)
  const convertPrice = (size) => {
    // Use the backend-calculated totalMetalPrice directly
    // It includes: metal cost + labour + making% + profit fixed + profit%
    // Frontend just adds the selected diamond quality price on top
    return Number(size?.metal?.totalMetalPrice || 0);
  };

  // Lift the engagement centre-diamond selection (carat/colour/clarity + its
  // rate-card price) up from the chooser.
  const handleCentreStoneChange = useCallback((selData) => {
    if (!selData || !selData.carat) { setSelectedCentreStone(null); return; }
    setSelectedCentreStone({
      // Lab or natural — without this the order records a natural centre
      // stone as if it were lab, and they are not the same thing or the
      // same price.
      type: selData.type || "lab",
      carat: selData.carat,
      colour: selData.colour,
      clarity: selData.clarity,
      label: selData.label || `${selData.carat}ct`,
      pricePerCaratGBP: selData.pricePerCaratGBP || 0,
      totalGBP: selData.totalGBP || 0,
    });
  }, []);

  // Halo engagement build — the configurator lifts its live total + recipe selection.
  const handleEngagementChange = useCallback(({ totalGBP, selection, hasCentre }) => {
    setFinalPrice(Number(totalGBP) || 0);
    setEngagementSel(selection || null);
    setEngHasCentre(!!hasCentre);
  }, []);

  // Fetch the cheapest configured lab stone so the shown price starts with a
  // diamond included (the "from" price), before the customer picks one.
  useEffect(() => {
    const cs = productIdData?.centreStone;
    if (!cs?.enabled || cs.source !== "lab-feed") { setCheapestCentreStone(null); return; }
    axios
      .get(`${BASE_URL}/centre-stone/lab-cheapest`, {
        params: {
          shape: cs.shape || "Round",
          feed: "labgrownWhite",
          carats: (cs.carats || []).join(","),
          colours: (cs.colours || []).join(","),
          clarities: (cs.clarities || []).join(","),
        },
      })
      .then((res) => setCheapestCentreStone(res?.data?.found ? res.data : null))
      .catch(() => setCheapestCentreStone(null));
  }, [productIdData]);

  // ...and separately, the cheapest stone AT THE DEFAULT CARAT, which is what the
  // box opens on. The fetch above sweeps every carat, so it lands on the smallest
  // one — right for a "from" price, wrong for a pre-selection. Restricting it to
  // carats[0] keeps the carat the product was set up with (2ct on the pendants)
  // and only picks the cheapest colour/clarity within it. The response carries
  // totalGBP, which is what puts a real figure in the Diamond Cost line instead
  // of the £0.00 the old hand-rolled guess produced.
  useEffect(() => {
    const cs = productIdData?.centreStone;
    const defaultCarat = (cs?.carats || [])[0];
    if (!cs?.enabled || cs.source !== "lab-feed" || !defaultCarat) { setCheapestCentre(null); return; }
    axios
      .get(`${BASE_URL}/centre-stone/lab-cheapest`, {
        params: {
          shape: cs.shape || "Round",
          feed: "labgrownWhite",
          carats: String(defaultCarat),
          colours: (cs.colours || []).join(","),
          clarities: (cs.clarities || []).join(","),
        },
      })
      .then((res) => setCheapestCentre(res?.data?.found ? res.data : null))
      .catch(() => setCheapestCentre(null));
  }, [productIdData]);

  // Recompute the displayed total when the selection (or the cheapest "from"
  // stone) changes. Size/quality changes fold it in via getCentreStonePrice.
  useEffect(() => {
    const size = variationSizes?.find((s) => s.sizeLabel === sizeName);
    if (!size) return;
    const metalPrice = convertPrice(size);
    const totals = getSizeQualityTotals(size);
    const cs = getCentreStonePrice(selectedQuality, selectedCentreStone);
    setFinalPrice(priceForSize(size, totals[selectedQuality] || 0, cs));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCentreStone, cheapestCentreStone]);

  const formatPrice = (price) => {
    return Number(price).toLocaleString("en-GB", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  /** The chain step, built once and rendered on BOTH product paths.
   *
   * It used to live inline inside the `!isHaloBuild` branch, which meant the ELEVEN
   * chain-enabled pendants that are engagement builds — every claw-set and halo pendant —
   * showed no chain control at all, while their headline price and their cart line already
   * carried one. Everything else was already path-agnostic: `withAddOns()` feeds the price
   * block, and both addCart branches send `chainOption`. Only the control was missing.
   *
   * Held as a node rather than duplicated so the two paths cannot drift; the halo path
   * renders it through EngagementBuilder's `chainSlot`, which puts it in the same place
   * relative to Size and Quality as it sits here. */
  const chainBlock = chainAvailable ? (
    <div className={styles.configStep}>
      <div className={styles.stepLabelRow}>
        <span className={styles.stepLabel}>Chain</span>
        {chainSelected && (
          <span style={{ fontSize: 12, color: "#8a6d1f", fontWeight: 600 }}>
            included &middot; {"£"}{formatPrice(chainPrice)}
          </span>
        )}
      </div>
      <Select
        value={chainLength === "" ? "" : chainLength || undefined}
        onChange={(value) => setChainLength(value)}
        className={styles.sizeDropdown}
        popupClassName={styles.sizeDropdownPopup}
        options={[
          // The default, and it leads the list: the chain is an add-on, not
          // something to opt out of.
          { value: "", label: "Add chain" },
          ...chainLengths.map((l) => ({
            value: l,
            // The metal is named whenever the chain is not in the pendant's own
            // metal — we stock 18K, so a 9K pendant hangs on an 18K chain and the
            // customer has to see that here, not discover it later.
            label: `${l}${chainMetalLabel ? ` ${chainMetalLabel}` : ""} chain — +£${formatPrice(Number(chainForMetal?.[l]?.gbp || 0))}`,
          })),
        ]}
      />
      <p style={{ fontSize: 12, color: "#888", margin: "8px 0 0", lineHeight: 1.6 }}>
        {chainSelected
          ? (chainMetalLabel
              ? `Supplied on a ${chainMetalLabel} chain — the only metal we stock chains in — charged at cost.`
              : "Supplied on a matching chain in the same metal, at cost.")
          : "Pendant only. Add a chain above if you would like one."}
      </p>
    </div>
  ) : null;

  /** The picture-enamelling step, built once and rendered on BOTH product paths.
   *
   * Same lesson the chain block learned the hard way: held as a node rather than duplicated,
   * so the plain path and the halo builder cannot drift into showing different controls for
   * the same charge. A Select rather than a checkbox for the same reason the chain uses one —
   * the two add-ons then read as one pair of choices rather than two different idioms.
   *
   * The (i) opens the explainer. It is a real button, not a decorated span: the water limit
   * behind it is a point-of-sale disclosure and has to be reachable by keyboard, not only by
   * a mouse that happens to find a 16px glyph. */
  const enamelBlock = enamelAvailable ? (
    <div className={styles.configStep}>
      <div className={styles.stepLabelRow}>
        <span className={styles.stepLabel}>
          {PICTURE_ENAMELLING_LABEL}
          <button
            type="button"
            onClick={() => setShowEnamelInfo(true)}
            aria-label="What is picture enamelling?"
            title="What is picture enamelling?"
            style={{
              marginLeft: 6,
              width: 16,
              height: 16,
              lineHeight: "14px",
              padding: 0,
              borderRadius: "50%",
              border: "1px solid #C5A028",
              background: "transparent",
              color: "#C5A028",
              fontSize: 11,
              fontWeight: 700,
              fontStyle: "italic",
              fontFamily: "Georgia, serif",
              cursor: "pointer",
              verticalAlign: "middle",
            }}
          >
            i
          </button>
        </span>
        {enamelSelected && (
          <span style={{ fontSize: 12, color: "#8a6d1f", fontWeight: 600 }}>
            included &middot; {"£"}{formatPrice(Number(enamelCfg?.gbp || 0))}
          </span>
        )}
      </div>
      <Select
        value={enamelSelected ? "yes" : ""}
        onChange={(value) => setEnamelSelected(value === "yes")}
        className={styles.sizeDropdown}
        popupClassName={styles.sizeDropdownPopup}
        options={[
          // Leads the list, and is where the page starts: enamelling is an add-on, not
          // something to opt out of.
          { value: "", label: "No enamelling" },
          {
            value: "yes",
            label: `Add picture enamelling — +£${formatPrice(Number(enamelCfg?.gbp || 0))}`,
          },
        ]}
      />
      <p style={{ fontSize: 12, color: "#888", margin: "8px 0 0", lineHeight: 1.6 }}>
        {enamelSelected
          ? "Your photograph printed in colour on the piece and sealed under a clear lacquer. We’ll be in touch for the image after you order."
          : "Add your own photograph, printed in colour and lacquered."}
      </p>
    </div>
  ) : null;

  const [qualityColumns, setQualityColumns] = useState([]);

  useEffect(() => {
    axios.get(`${BASE_URL}/menu/stone_quality_columns`).then(res => {
      const cols = res?.data?.data;
      if (Array.isArray(cols) && cols.length > 0) setQualityColumns(cols);
    }).catch(() => {});
  }, []);

  // Memoized so its reference is STABLE across renders. Un-memoized this built a
  // new object every render, which made getShareFields() (a useCallback with
  // qualityLabels in its deps) a new function every render, which made the
  // `[getShareFields]` effect below run after every commit and call
  // setShareFieldToggles with a fresh object — re-render → new qualityLabels →
  // … an infinite render loop that churned the heavy AddCart tree (antd portals +
  // react-slick) until the tab ran out of memory ("Aw, Snap! Out of Memory" after
  // the page was left open a while). Keep it memoized.
  const qualityLabels = useMemo(
    () => Object.fromEntries(qualityColumns.map(q => [q.key, q.label.toUpperCase()])),
    [qualityColumns]
  );

  const buildWhatsAppUrl = () => {
    const lines = [
      `Hi, I have a question about:`,
      ``,
      `*${productIdData?.Product_Name || "Product"}*`,
      `SKU: ${productIdData?.SKU_Code || "—"}`,
      `Brand: ${productIdData?.Brand?.Brand_Name || "—"}`,
    ];
    if (variationData?.variationName) {
      lines.push(`Purity: ${variationData.variationName}`);
    }
    if (selectedColor?.color) {
      lines.push(`Colour: ${selectedColor.color}`);
    }
    if (sizeName) {
      lines.push(`Size: ${sizeName}`);
    }
    if (selectedQuality) {
      lines.push(`Quality: ${qualityLabels[selectedQuality] || selectedQuality}`);
    }
    lines.push(`Price: £${formatPrice(withAddOns(finalPrice))}`);
    lines.push(``);
    lines.push(`Could you help me with this?`);
    return `https://wa.me/447793219535?text=${encodeURIComponent(lines.join("\n"))}`;
  };

  // ---- Share-to-WhatsApp (Quote your client) helpers ----------------------
  const getShareFields = useCallback(() => {
    const fields = [];
    const brand = productIdData?.Brand?.Brand_Name;
    if (brand) fields.push({ key: "brand", label: "Brand", value: brand });
    const purity = variationData?.variationName;
    if (purity) fields.push({ key: "metal", label: "Metal", value: purity });
    if (selectedColor?.color) {
      fields.push({ key: "colour", label: "Colour", value: selectedColor.color });
    }
    if (sizeName) fields.push({ key: "size", label: "Size", value: sizeName });
    if (selectedCentreStone?.carat) {
      fields.push({
        key: "centreStone",
        label: "Centre stone",
        value: `${selectedCentreStone.carat}ct`,
      });
    }
    if (selectedQuality) {
      fields.push({
        key: "stoneQuality",
        label: "Stone quality",
        value: qualityLabels[selectedQuality] || selectedQuality,
      });
    }
    if (engravingText?.trim()) {
      fields.push({ key: "engraving", label: "Engraving", value: engravingText.trim() });
    }
    // The shared quote carries the add-on's PRICE inside it, so it has to name the add-on
    // too — a client reading £25 more than the website without a line saying why is a
    // question the retailer has to field.
    if (enamelAvailable && enamelSelected) {
      fields.push({
        key: "enamelling",
        label: PICTURE_ENAMELLING_LABEL,
        value: `Yes — +£${formatPrice(Number(enamelCfg?.gbp || 0))}`,
      });
    }
    return fields;
  }, [productIdData, variationData, selectedColor, sizeName, selectedCentreStone, selectedQuality, qualityLabels, engravingText, enamelAvailable, enamelSelected, enamelCfg]);

  // Keep shareFieldToggles in sync with available fields; default new keys ON
  useEffect(() => {
    setShareFieldToggles((prev) => {
      const next = {};
      getShareFields().forEach((f) => {
        next[f.key] = prev[f.key] ?? true;
      });
      return next;
    });
  }, [getShareFields]);

  const computeSharedPrice = () => {
    const base = withAddOns(finalPrice);
    const withMarkup = shareMarkupMode === "amount"
      ? base + (Number(shareMarkupAmount) || 0)
      : base * (1 + (Number(shareMarkupPct) || 0) / 100);
    return sharePlusVAT ? withMarkup * 1.2 : withMarkup;
  };

  const computeMarkupDelta = () => {
    const base = withAddOns(finalPrice);
    return shareMarkupMode === "amount"
      ? Number(shareMarkupAmount) || 0
      : base * ((Number(shareMarkupPct) || 0) / 100);
  };

  const buildShareMessage = () => {
    const lines = [];
    const name = productIdData?.Product_Name || "Product";
    lines.push(`*${name}*`);
    const detailLines = [];
    if (shareIncludeSku && productIdData?.SKU_Code) {
      detailLines.push(`• SKU:  ${productIdData.SKU_Code}`);
    }
    getShareFields()
      .filter((f) => shareFieldToggles[f.key])
      .forEach((f) => detailLines.push(`• ${f.label}:  ${f.value}`));
    if (detailLines.length) {
      lines.push("");
      lines.push(...detailLines);
    }
    if (shareIncludePrice) {
      lines.push("");
      lines.push(`*£${formatPrice(computeSharedPrice())}*`);
      lines.push(sharePlusVAT ? "_Price includes VAT_" : "_Price excludes VAT_");
    }
    return lines.join("\n");
  };

  const fetchShareImageBlob = async () => {
    if (!singleImg) return null;
    try {
      const res = await fetch(`${BASE_URL}/${singleImg}`);
      if (!res.ok) return null;
      const raw = await res.blob();
      // Re-encode to PNG so clipboard.write accepts it everywhere
      try {
        const bitmap = await createImageBitmap(raw);
        const canvas = document.createElement("canvas");
        canvas.width = bitmap.width;
        canvas.height = bitmap.height;
        canvas.getContext("2d").drawImage(bitmap, 0, 0);
        const png = await new Promise((r) => canvas.toBlob(r, "image/png"));
        return png || raw;
      } catch {
        return raw;
      }
    } catch {
      return null;
    }
  };

  const isMobileDevice = () => {
    if (typeof navigator === "undefined") return false;
    if (navigator.userAgentData?.mobile === true) return true;
    if (navigator.userAgentData?.mobile === false) return false;
    const ua = navigator.userAgent || "";
    return /Android|iPhone|iPad|iPod|Mobile|BlackBerry|webOS|Opera Mini|IEMobile/i.test(ua);
  };

  const logQuoteShare = () => {
    try {
      const base = withAddOns(finalPrice);
      const delta = computeMarkupDelta();
      const pctEquivalent =
        shareMarkupMode === "amount" && base > 0
          ? (delta / base) * 100
          : Number(shareMarkupPct) || 0;
      const amountEquivalent =
        shareMarkupMode === "amount"
          ? Number(shareMarkupAmount) || 0
          : delta;
      const payload = {
        productId: resolvedProductId,
        skuCode: productIdData?.SKU_Code || "",
        productTitle: productIdData?.Product_Name || "",
        metal: variationData?.variationName || "",
        colour: selectedColor?.color || "",
        size: sizeName || "",
        basePrice: base,
        markupMode: shareMarkupMode,
        markupPct: pctEquivalent,
        markupAmount: amountEquivalent,
        plusVAT: !!sharePlusVAT,
        finalPrice: computeSharedPrice(),
      };
      // Fire-and-forget — never block the user on logging
      axios
        .post(`${BASE_URL}/quote-shares`, payload, {
          headers: userToken ? { Authorization: userToken } : {},
        })
        .catch(() => {});
    } catch (_) {
      // swallow — logging must never break the share flow
    }
  };

  const handleShareToWhatsApp = async () => {
    if (shareSending) return;
    setShareSending(true);
    const text = buildShareMessage();
    logQuoteShare();
    try {
      const blob = await fetchShareImageBlob();
      const file = blob
        ? new File(
            [blob],
            `${productIdData?.SKU_Code || "product"}.png`,
            { type: blob.type || "image/png" }
          )
        : null;

      // Mobile path: real attachment via Web Share API.
      // Only use this on actual mobile devices — on desktop Windows/macOS,
      // navigator.share triggers the OS share sheet (not WhatsApp directly),
      // so we route desktop straight to wa.me instead.
      if (
        isMobileDevice() &&
        file &&
        navigator.canShare &&
        navigator.canShare({ files: [file] })
      ) {
        try {
          await navigator.share({ files: [file], text });
          setShowShareModal(false);
          return;
        } catch (err) {
          if (err?.name === "AbortError") return;
          // fall through to desktop path
        }
      }

      // Desktop path: copy image to clipboard, then open wa.me with prefilled text
      let pasted = false;
      if (blob && navigator.clipboard && window.ClipboardItem) {
        try {
          await navigator.clipboard.write([
            new ClipboardItem({ [blob.type || "image/png"]: blob }),
          ]);
          pasted = true;
        } catch {}
      }
      window.open(
        `https://wa.me/?text=${encodeURIComponent(text)}`,
        "_blank",
        "noopener,noreferrer"
      );
      toast.success(pasted ? "Image copied to clipboard" : "WhatsApp opened");
      setShowShareModal(false);
    } catch (err) {
      toast.error("Couldn't share to WhatsApp");
    } finally {
      setShareSending(false);
    }
  };

  const productTabs = [
    {
      key: "1",
      label: "DESCRIPTION",
      children: (
        <div className={styles.tabContent}>
          <div className={styles.descriptionBlock}>
            <Description descriptions={productIdData?.Description} />
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: "SPECIFICATIONS",
      children: (
        <div className={styles.tabContent}>
          <div className={styles.specGrid}>
            <div className={styles.specCard}>
              <div className={styles.specCardIcon}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="2" y1="4" x2="2" y2="20" />
                  <line x1="5" y1="4" x2="5" y2="20" />
                  <line x1="7.5" y1="4" x2="7.5" y2="20" />
                  <line x1="11" y1="4" x2="11" y2="20" />
                  <line x1="13" y1="4" x2="13" y2="20" />
                  <line x1="16" y1="4" x2="16" y2="20" />
                  <line x1="18.5" y1="4" x2="18.5" y2="20" />
                  <line x1="21" y1="4" x2="21" y2="20" />
                </svg>
              </div>
              <div className={styles.specCardLabel}>SKU</div>
              <div className={styles.specCardValue}>{productIdData?.SKU_Code || "—"}</div>
            </div>
            <div className={styles.specCard}>
              <div className={styles.specCardIcon}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z" />
                  <line x1="7" y1="7" x2="7.01" y2="7" />
                </svg>
              </div>
              <div className={styles.specCardLabel}>Brand</div>
              <div className={styles.specCardValue}>{productIdData?.Brand?.Brand_Name || "—"}</div>
            </div>
            <div className={styles.specCard}>
              <div className={styles.specCardIcon}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M6 3L1 10l11 12L23 10l-5-7z" />
                  <path d="M1 10h22" />
                  <path d="M6 3l6 7 6-7" />
                  <path d="M7 10l5 12 5-12" />
                </svg>
              </div>
              <div className={styles.specCardLabel}>Diamond Weight</div>
              <div className={styles.specCardValue}>
                {(() => {
                  const size = variationSizes?.find((s) => s.sizeLabel === sizeName);
                  const dcs = size?.diamondSizes?.[0]?.diamondComponents || [];
                  const totalCrt = dcs.reduce((sum, dc) => sum + Number(dc.totalCrt || 0), 0);
                  return totalCrt > 0 ? <>{totalCrt.toFixed(3)} ct<br/><span style={{ fontSize: 10, color: "#bbb", fontWeight: 400 }}>approx</span></> : "—";
                })()}
              </div>
            </div>
            <div className={styles.specCard}>
              <div className={styles.specCardIcon}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M2 12h20" />
                  <path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z" />
                  <path d="M4.93 7h14.14" />
                  <path d="M4.93 17h14.14" />
                </svg>
              </div>
              <div className={styles.specCardLabel}>Origin</div>
              <div className={styles.specCardValue}>
                {(() => {
                  const quality = selectedQuality || "";
                  const size = variationSizes?.find((s) => s.sizeLabel === sizeName);
                  const dcs = size?.diamondSizes?.[0]?.diamondComponents || [];
                  if (!quality || dcs.length === 0) return "—";
                  return quality.toLowerCase().includes("lab") ? "Lab Grown" : "Natural";
                })()}
              </div>
            </div>
            <div className={styles.specCard}>
              <div className={styles.specCardIcon}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="9" />
                  <circle cx="12" cy="12" r="6" />
                  <line x1="12" y1="3" x2="12" y2="6" />
                  <line x1="12" y1="18" x2="12" y2="21" />
                  <line x1="3" y1="12" x2="6" y2="12" />
                  <line x1="18" y1="12" x2="21" y2="12" />
                </svg>
              </div>
              <div className={styles.specCardLabel}>Size</div>
              {/* A halo build has no variation, so sizeName is the vestigial
                  "Default" the recipe hangs its weight off — read the build's
                  own label instead, which is null when no size was asked for. */}
              <div className={styles.specCardValue}>{(isHaloBuild ? engagementSel?.sizeLabel : sizeName) || "—"}</div>
            </div>
          </div>
        </div>
      ),
    },
    {
      key: "3",
      label: "DIAMOND OPTIONS",
      children: (
        <div className={styles.tabContent}>
          <p className={styles.diamondIntro}>
            We use IGI grading standards, ensuring superior quality. All diamonds
            are expertly selected for brilliance and value. Choose the best option
            for your client's needs.
          </p>

          <div className={styles.diamondScroll}>
            <div className={styles.diamondGrid}>
            {/* Option 1 */}
            <div className={styles.diamondCard}>
              <div className={styles.diamondCardIcon}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2">
                  <polygon points="12,2 22,9 18,22 6,22 2,9" />
                  <polyline points="2,9 12,13 22,9" />
                  <line x1="12" y1="2" x2="12" y2="13" />
                  <line x1="6" y1="22" x2="12" y2="13" />
                  <line x1="18" y1="22" x2="12" y2="13" />
                </svg>
              </div>
              <div className={styles.diamondCardBadge}>Ethical</div>
              <h4 className={styles.diamondCardTitle}>LAB VVS/VS</h4>
              <p className={styles.diamondCardGrade}>EF Colour &middot; VVS-VS Clarity</p>
              <p className={styles.diamondCardDesc}>
                The finest option with exceptional near-colorless brilliance and
                minimal inclusions, even under magnification. Outstanding sparkle
                for those seeking the highest standard.
              </p>
              <span className={styles.diamondCardTag}>IGI: E-F VVS-VS</span>
            </div>

            {/* Option 2 */}
            <div className={styles.diamondCard}>
              <div className={styles.diamondCardIcon}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2">
                  <polygon points="12,2 22,9 18,22 6,22 2,9" />
                  <polyline points="2,9 12,13 22,9" />
                  <line x1="12" y1="2" x2="12" y2="13" />
                </svg>
              </div>
              <div className={styles.diamondCardBadge}>Premium</div>
              <h4 className={styles.diamondCardTitle}>FG VS</h4>
              <p className={styles.diamondCardGrade}>FG Colour &middot; VS Clarity</p>
              <p className={styles.diamondCardDesc}>
                Premium quality with minimal inclusions, ensuring a clean, radiant
                appearance. Perfect for those desiring high-quality at a competitive price.
              </p>
              <span className={styles.diamondCardTag}>IGI: F-G VS1-VS2</span>
            </div>

            {/* Option 3 */}
            <div className={styles.diamondCard}>
              <div className={styles.diamondCardIcon}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2">
                  <polygon points="12,2 22,9 18,22 6,22 2,9" />
                  <polyline points="2,9 12,13 22,9" />
                </svg>
              </div>
              <div className={styles.diamondCardBadge}>Best Value</div>
              <h4 className={styles.diamondCardTitle}>GH SI</h4>
              <p className={styles.diamondCardGrade}>GH Colour &middot; VS/SI Clarity</p>
              <p className={styles.diamondCardDesc}>
                Near-colorless with minor inclusions typically invisible to the naked
                eye. Combines quality and value, offering impressive brilliance at a
                reasonable cost.
              </p>
              <span className={styles.diamondCardTag}>IGI: G-H VS-SI</span>
            </div>

            {/* Option 4 */}
            <div className={styles.diamondCard}>
              <div className={styles.diamondCardIcon}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2">
                  <polygon points="12,2 22,9 18,22 6,22 2,9" />
                </svg>
              </div>
              <div className={styles.diamondCardBadge}>Budget Friendly</div>
              <h4 className={styles.diamondCardTitle}>HI SI</h4>
              <p className={styles.diamondCardGrade}>HI Colour &middot; SI Clarity</p>
              <p className={styles.diamondCardDesc}>
                A bright diamond with slight inclusions visible under magnification
                but hard to detect with the naked eye. Balances affordability and
                size for budget-conscious buyers.
              </p>
              <span className={styles.diamondCardTag}>IGI: H-I SI1-SI2</span>
            </div>
            </div>
            <div className={styles.diamondScrollHint}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </div>
          </div>

        </div>
      ),
    },
    {
      key: "4",
      label: "SHIPPING & RETURNS",
      children: (
        <div className={styles.tabContent}>
          <div className={styles.shippingGrid}>
            {/* Shipping */}
            <div className={styles.shippingBlock}>
              <div className={styles.shippingBlockHeader}>
                <div className={styles.shippingBlockIcon}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="1" y="3" width="15" height="13" />
                    <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
                    <circle cx="5.5" cy="18.5" r="2.5" />
                    <circle cx="18.5" cy="18.5" r="2.5" />
                  </svg>
                </div>
                <h4>Shipping</h4>
              </div>
              <div className={styles.shippingFeatures}>
                <div className={styles.shippingFeature}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
                  <span>Worldwide delivery available</span>
                </div>
                <div className={styles.shippingFeature}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
                  <span>Fully insured shipping on all orders</span>
                </div>
                <div className={styles.shippingFeature}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
                  <span>Estimated delivery dates provided at checkout</span>
                </div>
                <div className={styles.shippingFeature}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
                  <span>Weight-based rates for applicable items</span>
                </div>
              </div>
              <p className={styles.shippingNote}>
                Some restrictions may apply to international destinations.
                Shipping rates are weight-based where applicable — weights are
                rounded up to the next full pound.
              </p>
            </div>

            {/* Returns */}
            <div className={styles.shippingBlock}>
              <div className={styles.shippingBlockHeader}>
                <div className={styles.shippingBlockIcon}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="1 4 1 10 7 10" />
                    <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" />
                  </svg>
                </div>
                <h4>Returns</h4>
              </div>
              <div className={styles.shippingFeatures}>
                <div className={styles.shippingFeature}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
                  <span>14-day return window from delivery</span>
                </div>
                <div className={styles.shippingFeature}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
                  <span>Free return shipping for faulty or incorrect items</span>
                </div>
                <div className={styles.shippingFeature}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
                  <span>Refunds processed within 14 days of inspection</span>
                </div>
                <div className={styles.shippingFeature}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
                  <span>Items must be in original condition and packaging</span>
                </div>
              </div>
              <p className={styles.shippingNote}>
                To initiate a return, log in to your account and select "Return
                Item(s)" under your completed orders. We'll notify you via email
                once your return is inspected.
              </p>
            </div>
          </div>
        </div>
      ),
    },
  ];

  // A colour's photo: the first image the admin mapped to it. Looked up across all
  // variations (every one carries the same colour map), so a Platinum variation
  // can still find the White Gold shot.
  const colourPhoto = (colourName) =>
    (productIdData?.Variation || [])
      .flatMap((v) => v.colors || [])
      .find((c) => c?.active !== false && c.color === colourName && c.images?.length > 0)
      ?.images?.[0]?.path || null;

  const handleOnClickVariation = (variation) => {
    const sizes = variation?.sizes || [];
    // Keep same size label if it exists in the new variation, otherwise first
    const matchedSize = sizeName ? sizes.find(s => s.sizeLabel === sizeName) : null;
    const targetSize = matchedSize || sizes[0];

    setVariationData(variation);
    setVariationSizes(sizes);
    setVariationId(variation?.variationId);

    // Metal type and colour are separate choices: switching between golds leaves the
    // photos alone — only a colour click changes the image. A gold keeps the
    // customer's colour when it offers it (as the size carries over), else ticks
    // its first colour, so the persistent 360 always has a concrete finish.
    // Platinum/Silver hide the swatches and have no photos of their own, so they
    // show the White Gold shot (the closest look — the 360 maps them to white too)
    // and leave the pick untouched. Returning to a gold puts that colour's photo back.
    const toWhiteOnly = /(platinum|silver)/i.test(variation?.variationName || "");
    const fromWhiteOnly = /(platinum|silver)/i.test(variationData?.variationName || "");
    if (toWhiteOnly) {
      const white = colourPhoto("White Gold");
      if (white) setSingleImg(white);
    } else {
      const activeColours = (variation?.colors || []).filter((c) => c?.active !== false);
      const colour = (pickedColor && activeColours.find((c) => c.color === pickedColor.color)) || activeColours[0] || null;
      setPickedColor(colour);
      const photo = fromWhiteOnly && colour ? colourPhoto(colour.color) : null;
      if (photo) setSingleImg(photo);
    }

    if (targetSize) {
      setSelectedMetalSizeId(targetSize?._id);
      setSelectedDiamondSizeId(targetSize?.diamondSizes?.[0]?._id);
      setSizeName(targetSize?.sizeLabel);

      const metalPrice = convertPrice(targetSize);

      const totals = getSizeQualityTotals(targetSize);
      const qualityKeys = Object.keys(totals);
      const defaultQualityKey = qualityKeys.find(k => totals[k] > 0) || qualityKeys[0];
      const newQuality = (selectedQuality && qualityKeys.includes(selectedQuality)) ? selectedQuality : defaultQualityKey;
      setSelectedQuality(newQuality);
      const csPrice = getCentreStonePrice(newQuality, selectedCentreStone);
      setFinalPrice(metalPrice + (totals[newQuality] || 0) + csPrice);
    }
  };

  useEffect(() => {
    if (!productIdData?.Variation?.length) return;

    const firstVariation = productIdData.Variation[0];
    const sizes = firstVariation?.sizes || [];
    const firstSize = sizes[0];

    setVariationData(firstVariation);
    setVariationSizes(sizes);
    setVariationId(firstVariation?.variationId);

    // Pick the first colour, the same default handleOnClickVariation falls back to
    // when the metal type changes. Without this the page opened with metal and quality
    // chosen but colour not, and the swatches are tinted to show the metal they
    // represent — so "Yellow Gold" already looks gold whether or not it has been
    // picked. Add to Cart then refused with "Please select color" against a row
    // that looked chosen. Now the tick is on one from the start, and it is
    // consistent with every other option on the page.
    const initialColours = (firstVariation?.colors || []).filter((c) => c?.active !== false);
    const initialWhiteOnly = /(platinum|silver)/i.test(firstVariation?.variationName || "");
    const initialColour = initialWhiteOnly ? null : (initialColours[0] || null);
    setPickedColor(initialColour);

    const productImages = productIdData?.Product_Images || [];
    setImgArr(productImages);
    // A piece that opens on Platinum/Silver opens on its White Gold shot, as
    // selecting one does; everything else opens on the lead photo.
    setSingleImg((initialWhiteOnly && colourPhoto("White Gold")) || productImages?.[0]?.path || "");

    if (firstSize) {
      setSizeName(firstSize?.sizeLabel);
      setSelectedMetalSizeId(firstSize?._id);
      setSelectedDiamondSizeId(firstSize?.diamondSizes?.[0]?._id);

      const metalPrice = convertPrice(firstSize);

      const totals = getSizeQualityTotals(firstSize);
      // Default to first quality with price > 0, or first available
      const qualityKeys = Object.keys(totals);
      const defaultQualityKey = qualityKeys.find(k => totals[k] > 0) || qualityKeys[0];
      setSelectedQuality(defaultQualityKey);
      setFinalPrice(metalPrice + (totals[defaultQualityKey] || 0) + getCentreStonePrice(defaultQualityKey, selectedCentreStone));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productIdData]);

  // Halo engagement builds have NO variations, so the variation effect above
  // skips them — load the image gallery directly from the product images.
  useEffect(() => {
    if (!productIdData?._id || productIdData?.Variation?.length) return;
    const imgs = productIdData?.Product_Images || [];
    setImgArr(imgs);
    setSingleImg(imgs?.[0]?.path || "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productIdData]);

  const toggleLike = (value, fev) => {
    const obj = {
      productId: value,
    };
    const onSuccessCallback = () => {
      if (isLiked === false || fev === false) {
        dispatch(getWishListApi(userToken));
        setIsLiked(!isLiked);
      } else {
        if (likeCounter > 0) {
          setIsLiked(!isLiked);
          dispatch(getWishListApi(userToken));
        }
      }
    };
    dispatch(addWishList(obj, onSuccessCallback, userToken));
  };

  const home = () => {
    navigate(routes.loginUrl);
  };

  const SlickArrowLeft = ({ onClick }) => (
    <button type="button" className={styles.carouselArrow + " " + styles.carouselArrowLeft} onClick={onClick}>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="15 18 9 12 15 6" />
      </svg>
    </button>
  );

  const SlickArrowRight = ({ onClick }) => (
    <button type="button" className={styles.carouselArrow + " " + styles.carouselArrowRight} onClick={onClick}>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="9 6 15 12 9 18" />
      </svg>
    </button>
  );

  const getCarouselSettings = (itemCount) => ({
    dots: false,
    infinite: itemCount > 4,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    swipeToSlide: true,
    draggable: itemCount > 4,
    prevArrow: itemCount > 4 ? <SlickArrowLeft /> : <></>,
    nextArrow: itemCount > 4 ? <SlickArrowRight /> : <></>,
    responsive: [
      {
        breakpoint: 1440,
        settings: { slidesToShow: 4 },
      },
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3, infinite: itemCount > 3, draggable: itemCount > 3 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2, infinite: itemCount > 2, draggable: itemCount > 2 },
      },
      {
        breakpoint: 426,
        settings: { slidesToShow: 1.5, arrows: false, infinite: itemCount > 1 },
      },
      {
        breakpoint: 376,
        settings: { slidesToShow: 1.3, arrows: false, infinite: itemCount > 1 },
      },
    ],
  });

  // Get current size + quality totals for quality cards

  const currentSize = variationSizes?.find((s) => s.sizeLabel === sizeName);
  const currentDiamondComponents =
    currentSize?.diamondSizes?.[0]?.diamondComponents || [];
  const currentTotals = getQualityTotals(currentDiamondComponents);
  const currentMetalPrice = convertPrice(currentSize);
  // Lab-feed engagement rings show a "From" price (base + cheapest diamond) until a stone is picked.
  const showFromPrice = isHaloBuild
    ? !engHasCentre
    : (productIdData?.centreStone?.enabled && productIdData?.centreStone?.source === "lab-feed" && !selectedCentreStone);

  return (
    <div className={styles.page}>
      {/* Breadcrumb — full-width bar matching Category/Shop page */}
      <div className={styles.breadcrumbBar}>
        <div className={styles.breadcrumbInner}>
          <Breadcrumb
            className={styles.breadcrumb}
            items={[
              { title: <Link to="/">Home</Link> },
              ...(isBrandedProduct
                ? [{
                    title: (
                      <Link
                        to={buildCategoryPath({ brandName: productBrandName })}
                        state={{ brandName: productBrandName, menuGroup: "branded_jewellery" }}
                      >
                        {productBrandName}
                      </Link>
                    ),
                  }]
                : []),
              ...(menuLevel1
                ? [{
                    title: (
                      <Link
                        to={isBrandedProduct
                          ? buildCategoryPath({ brandName: productBrandName, menuLevel1 })
                          : buildCategoryPath({ menuLevel1 })}
                        state={isBrandedProduct
                          ? { brandName: productBrandName, menuLevel1, menuGroup: "branded_jewellery" }
                          : { menuLevel1 }}
                      >
                        {menuLevel1}
                      </Link>
                    ),
                  }]
                : productCategory
                  ? [{ title: <Link to={buildCategoryPath({ menuLevel1: productCategory })}>{productCategory}</Link> }]
                  : isBrandedProduct
                    ? []
                    : [{ title: "Product" }]),
              ...(menuLevel2
                ? [{
                    title: (
                      <Link
                        to={isBrandedProduct
                          ? buildCategoryPath({ brandName: productBrandName, menuLevel1, menuLevel2 })
                          : buildCategoryPath({ menuLevel1, menuLevel2 })}
                        state={isBrandedProduct
                          ? { brandName: productBrandName, menuLevel1, menuLevel2, menuGroup: "branded_jewellery" }
                          : { menuLevel1, menuLevel2 }}
                      >
                        {menuLevel2}
                      </Link>
                    ),
                  }]
                : []),
              ...(menuLevel3
                ? [{
                    title: (
                      <Link
                        to={isBrandedProduct
                          ? buildCategoryPath({ brandName: productBrandName, menuLevel1, menuLevel2, menuLevel3 })
                          : buildCategoryPath({ menuLevel1, menuLevel2, menuLevel3 })}
                        state={isBrandedProduct
                          ? { brandName: productBrandName, menuLevel1, menuLevel2, menuLevel3, menuGroup: "branded_jewellery" }
                          : { menuLevel1, menuLevel2, menuLevel3 }}
                      >
                        {menuLevel3}
                      </Link>
                    ),
                  }]
                : []),
              { title: productIdData?.Product_Name || "Details" },
            ]}
          />
        </div>
      </div>

      <div className={styles.container}>
      {!showContent ? (
        <ProductPageLoader fadeOut={loaderFadeOut} />
      ) : (
        <div className={styles.contentFadeIn}>

          {/* ═══ PRODUCT SECTION (Two Column) ═══ */}
          <div className={styles.productSection}>

            {/* LEFT: Gallery */}
            <div className={styles.galleryColumn}>
              <div className={styles.galleryLayout}>

                {/* Vertical Thumbnails (Desktop) */}
                <div className={styles.thumbStrip}>
                  {imgArr?.map((img, index) => (
                    <div
                      key={index}
                      className={`${styles.thumbItem} ${singleImg === img.path ? styles.activeThumb : ""}`}
                      onClick={() => selectImage(img?.path)}
                    >
                      <img src={`${BASE_URL}/${img?.path}`} alt="thumbnail" />
                    </div>
                  ))}
                </div>

                {/* Main Image */}
                <div className={styles.mainImageArea}>
                  {productIdData?.Collections?.Collections && (
                    <span className={styles.productBadge}>
                      {productIdData.Collections.Collections}
                    </span>
                  )}

                  <div
                    className={styles.wishlistBtn}
                    onClick={() => toggleLike(resolvedProductId, productIdData?.isFavorite)}
                  >
                    {isLiked ? (
                      <HeartFilled style={{ color: "#C5A028" }} />
                    ) : (
                      <HeartOutlined style={{ color: "#C5A028" }} />
                    )}
                  </div>

                  <Image.PreviewGroup
                    items={(imgArr || []).map((img) => `${BASE_URL}/${img?.path}`)}
                    preview={{
                      visible: imgPreviewOpen,
                      current: previewIndex,
                      toolbarRender: () => null, // strip the default zoom / rotate / flip toolbar
                      onChange: (cur) => setPreviewIndex(cur),
                      onVisibleChange: (v) => setImgPreviewOpen(v),
                    }}
                  >
                    {/* One visible hero; clicking opens the lightbox at the selected
                        image and the built-in ‹ › arrows cycle the whole gallery. */}
                    <Image
                      preview={false}
                      src={singleImg ? `${BASE_URL}/${singleImg}` : ""}
                      className={styles.mainImage}
                      alt="Product"
                      style={{ cursor: "zoom-in" }}
                      onClick={() => {
                        const i = (imgArr || []).findIndex((im) => im?.path === singleImg);
                        setPreviewIndex(i < 0 ? 0 : i);
                        setImgPreviewOpen(true);
                      }}
                    />
                  </Image.PreviewGroup>
                  {activeEmbedId && webglSupported() && (
                    // Both desktop and mobile open the viewer INLINE (open360 →
                    // show360): desktop swaps the hero image, mobile renders the
                    // full-screen portal overlay below. (Mobile was briefly a
                    // new-tab <a> as an iOS-crash workaround; the real fixes —
                    // shared metal material + rhino WASM cleanup — landed, so the
                    // inline viewer is restored.)
                    <button
                      type="button"
                      onClick={open360}
                      aria-label="View in 360 degrees"
                      style={{ position: "absolute", right: 14, bottom: 14, zIndex: 5, display: "inline-flex", alignItems: "center", gap: 6, padding: "9px 15px", background: "rgba(17,17,17,0.85)", color: "#fff", border: "none", borderRadius: 999, cursor: "pointer", fontFamily: "Poppins, sans-serif", fontSize: 12, fontWeight: 700, letterSpacing: 0.5, boxShadow: "0 2px 10px rgba(0,0,0,0.28)" }}
                    >
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12a9 9 0 1 1-3-6.7" /><polyline points="21 3 21 9 15 9" /></svg>
                      360&deg;
                    </button>
                  )}
                  {/* Desktop: 360 viewer replaces the hero image inline */}
                  {desktop360Mounted && activeEmbedId && !isMobileDevice() && (
                    <div ref={desktop360ContainerRef} style={{ position: "absolute", inset: 0, zIndex: show360 ? 6 : -1, visibility: show360 ? "visible" : "hidden", pointerEvents: show360 ? "auto" : "none", background: "#fff", borderRadius: "inherit", overflow: "hidden" }}>
                      <iframe
                        ref={iframe360Ref}
                        title="360 view"
                        src={`https://thediamondrender.co.uk/embed/${activeEmbedId}?swatch=${desktopWhiteOnly || has360Colours ? "0" : "1"}${desktopMetalParam ? `&metal=${desktopMetalParam}` : ""}${isLowEndDevice() ? "&lowmem=1" : ""}`}
                        allow="fullscreen"
                        onError={() => { auto360EmbedRef.current = activeEmbedId; setShow360(false); setDesktop360Mounted(false); }}
                  style={{
                    // +1px on purpose. At a fractional container width this
                    // cross-origin iframe paints a subpixel short of its
                    // wrapper, leaving a 1px seam down the right edge and along
                    // the bottom. The overhang is clipped by the wrapper's
                    // overflow:hidden, so it costs nothing and closes the gap at
                    // any zoom or DPR — belt and braces with the white wrapper.
                    width: "calc(100% + 1px)", height: "calc(100% + 1px)", border: "none", display: "block",
                  }}
                      />
                      <Preloader360 ready={viewerReady} />
                      <div style={{ position: "absolute", top: 10, right: 10, zIndex: 8, display: "flex", flexDirection: "column", gap: 8 }}>
                        <button type="button" onClick={() => setShow360(false)} aria-label="Close 360 viewer" title="Close" style={{ ...TB360, fontSize: 20 }}>&times;</button>
                        <button type="button" onClick={toggle360Fullscreen} aria-label="Fullscreen" title="Fullscreen" style={TB360}><IconFullscreen /></button>
                        <button type="button" onClick={toggle360Orbit} aria-label="Toggle orbit" title="Orbit" style={{ ...TB360, background: orbit360 ? TB360_GOLD : TB360.background }}><IconOrbit /></button>
                        <button type="button" onClick={copy360ShareLink} aria-label="Copy link" title="Copy link" style={TB360}><IconShare /></button>
                      </div>
                      <div style={{ position: "absolute", bottom: 16, left: "50%", transform: "translateX(-50%)", zIndex: 7, pointerEvents: "none", opacity: show360Hint ? 1 : 0, transition: "opacity 0.5s", display: "inline-flex", alignItems: "center", gap: 7, padding: "7px 15px", background: "rgba(17,17,17,0.8)", color: "#fff", borderRadius: 999, fontFamily: "Poppins, sans-serif", fontSize: 12, fontWeight: 600, letterSpacing: 0.5, boxShadow: "0 2px 10px rgba(0,0,0,0.3)", whiteSpace: "nowrap" }}>
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12a9 9 0 1 1-3-6.7" /><polyline points="21 3 21 9 15 9" /></svg>
                        Drag to rotate
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Sample-image carat caption. Two admin pages can set it, so read
                  both: engagement rings carry it on `engagement` (EngagementAdd →
                  Images / 3D Model), ordinary products at the TOP LEVEL of the
                  product (ProductEdit → Images). A product is never both, so first
                  match wins. Placed BELOW the gallery row: galleryLayout is a flex
                  ROW, so inside it the caption gets pushed to the side — here it
                  reads centred under the hero photo + inline 360. */}
              {(() => {
                // Wording lives in utils/sampleImageCaption so the two admin previews
                // cannot drift from what the customer actually reads.
                //
                // The caption is CONDITIONAL: it only mentions a dimension the customer
                // has moved away from. Saying "shown in 8mm" to someone looking at the
                // 8mm is noise; the note earns its place only on a mismatch. Each half
                // drops independently, so picking a different carat at the photographed
                // width leaves just the carat clause.
                //
                // The selected width is a LABEL off the recipe ("8.0MM") while the
                // sample is free text ("8mm"), so the helper compares them numerically.
                // A product with no configurator passes no selection and keeps the full
                // sentence, which is the behaviour ordinary products already had.
                // Which surface is the customer actually looking at? `show360` — and ONLY
                // show360. On desktop the iframe stays MOUNTED behind a photo so that
                // switching back to the model doesn't reload it, and it is hidden with
                // `visibility: show360 ? "visible" : "hidden"`. So desktop360Mounted means
                // "the iframe exists", not "the model is on screen": including it left the
                // caption reading "Sample model shown for 6.0MM width" over a photograph
                // of the 8mm. Mobile mounts and unmounts, so show360 is right there too.
                const inModelView = show360;
                const selection = engagementSel
                  ? { carat: engagementSel.carat, width: selectedWidthLabel }
                  : undefined;
                const text = sampleImageCaption(
                  captionSourceFor(productIdData),
                  selection,
                  inModelView ? { mode: "model", modelWidth: activeModel?.width } : undefined,
                );
                if (!text) return null;
                return (
                  <p style={{ margin: "14px 0 0", textAlign: "center", fontSize: 12, color: "#777", fontFamily: "Poppins, sans-serif" }}>
                    {text}
                  </p>
                );
              })()}

              {/* Horizontal Thumbnails (Mobile) */}
              <div className={styles.thumbStripMobile}>
                {imgArr?.map((img, index) => (
                  <div
                    key={index}
                    className={`${styles.thumbItem} ${singleImg === img.path ? styles.activeThumb : ""}`}
                    onClick={() => selectImage(img?.path)}
                  >
                    <img src={`${BASE_URL}/${img?.path}`} alt="thumbnail" />
                  </div>
                ))}
              </div>
            </div>

            {/* Mobile: 360 viewer — portaled to <body> so it escapes any
               transformed ancestor and covers the FULL viewport (site header +
               quick-menu FAB included); 100dvh keeps it within the visible area. */}
            {show360 && activeEmbedId && isMobileDevice() && createPortal(
              <div style={{ position: "fixed", top: 0, left: 0, right: 0, height: "100dvh", zIndex: 2147483647, background: "#fff", overflow: "hidden" }}>
                <div style={{ position: "absolute", top: 16, right: 16, zIndex: 3, display: "flex", flexDirection: "column", gap: 10 }}>
                  <button type="button" onClick={close360} aria-label="Close 360 viewer" title="Close" style={{ ...TB360, width: 42, height: 42, background: "#111", fontSize: 24 }}>&times;</button>
                  <button type="button" onClick={toggle360Orbit} aria-label="Toggle orbit" title="Orbit" style={{ ...TB360, width: 42, height: 42, background: orbit360 ? TB360_GOLD : "#111" }}><IconOrbit /></button>
                  <button type="button" onClick={copy360ShareLink} aria-label="Copy link" title="Copy link" style={{ ...TB360, width: 42, height: 42, background: "#111" }}><IconShare /></button>
                </div>
                <iframe
                  ref={mobileIframe360Ref}
                  title="360 view"
                  src={`https://thediamondrender.co.uk/embed/${activeEmbedId}?swatch=1${embedMetalParam ? `&metal=${embedMetalParam}` : ""}${isLowEndDevice() ? "&lowmem=1" : ""}`}
                  allow="fullscreen"
                  onError={() => { auto360EmbedRef.current = activeEmbedId; setShow360(false); }}
                  style={{
                    // +1px on purpose. At a fractional container width this
                    // cross-origin iframe paints a subpixel short of its
                    // wrapper, leaving a 1px seam down the right edge and along
                    // the bottom. The overhang is clipped by the wrapper's
                    // overflow:hidden, so it costs nothing and closes the gap at
                    // any zoom or DPR — belt and braces with the white wrapper.
                    width: "calc(100% + 1px)", height: "calc(100% + 1px)", border: "none", display: "block",
                  }}
                />
                <Preloader360 ready={viewerReady} />
                <div style={{ position: "absolute", bottom: 22, left: "50%", transform: "translateX(-50%)", zIndex: 3, pointerEvents: "none", opacity: show360Hint ? 1 : 0, transition: "opacity 0.5s", display: "inline-flex", alignItems: "center", gap: 7, padding: "8px 16px", background: "rgba(17,17,17,0.8)", color: "#fff", borderRadius: 999, fontFamily: "Poppins, sans-serif", fontSize: 12, fontWeight: 600, letterSpacing: 0.5, boxShadow: "0 2px 10px rgba(0,0,0,0.3)", whiteSpace: "nowrap" }}>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12a9 9 0 1 1-3-6.7" /><polyline points="21 3 21 9 15 9" /></svg>
                  Drag to rotate
                </div>
              </div>,
              document.body,
            )}

            {/* RIGHT: Info */}
            <div className={styles.infoColumn}>

              {/* Product Header */}
              <h1 className={styles.productTitle}>
                {productIdData?.Product_Name}
              </h1>
              <div className={styles.skuLine}>
                SKU: {productIdData?.SKU_Code}
              </div>

              {/* Price Block */}
              <div className={styles.priceBlock}>
                <div className={styles.priceLabel}>Trade Price</div>
                <div className={styles.priceValue}>
                  {showFromPrice ? "From " : ""}{"\u00A3"}{formatPrice(withAddOns(finalPrice))}
                </div>
                <div className={styles.tagRow}>
                  {productIdData?.Brand?.Brand_Name && (
                    <span className={styles.productTag}>
                      {productIdData.Brand.Brand_Name}
                    </span>
                  )}
                  {productIdData?.Category?.map((cat, i) => (
                    <span key={i} className={styles.productTag}>
                      {cat?.Category_Name}
                    </span>
                  ))}
                </div>
              </div>

              {/* Cost Breakdown — privileged users only. No loading/error states by design. */}
              {costBreakdown && (
                <div style={{ margin: "20px 0", border: "1px solid #e8c94e", background: "#fffef5", padding: breakdownOpen ? "16px 24px 20px" : "10px 24px" }}>
                  <button
                    type="button"
                    onClick={toggleBreakdown}
                    aria-expanded={breakdownOpen}
                    style={{ display: "flex", alignItems: "center", gap: 10, width: "100%", padding: 0, background: "transparent", border: "none", cursor: "pointer", textAlign: "left", fontFamily: "Poppins, sans-serif", marginBottom: breakdownOpen ? 16 : 0 }}
                  >
                    <div style={{ height: 1, width: 20, background: "#C5A028" }} />
                    <span style={{ fontSize: 9, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", color: "#C5A028" }}>Cost Breakdown</span>
                    <div style={{ flex: 1, height: 1, background: "#C5A028" }} />
                    <span style={{ display: "inline-block", width: 12, height: 12, color: "#C5A028", transition: "transform 0.25s ease", transform: breakdownOpen ? "rotate(180deg)" : "rotate(0deg)" }}>
                      <svg viewBox="0 0 12 12" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" style={{ display: "block" }}>
                        <polyline points="3 4.5 6 7.5 9 4.5" />
                      </svg>
                    </span>
                  </button>

                  {/* Animated body — max-height + opacity. overflow:hidden so
                      the page layout below stays put while it transitions. */}
                  <div style={{
                    maxHeight: breakdownOpen ? "1200px" : 0,
                    opacity: breakdownOpen ? 1 : 0,
                    overflow: "hidden",
                    transition: "max-height 0.35s ease, opacity 0.25s ease",
                  }}>

                  {/* Cost rows — same as before, minus the single Your Price line */}
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    {[
                      { label: "Net Gold Weight", value: `${costBreakdown.netGoldWeight}g`, muted: true },
                      { label: "Metal Cost", value: `£${costBreakdown.metalCost.toFixed(2)}` },
                      { label: "Diamond Cost", value: `£${costBreakdown.diamondCost.toFixed(2)}` },
                      { label: "Making Cost", value: `£${costBreakdown.makingCost.toFixed(2)}` },
                      { label: "Total Landed Cost", value: `£${(costBreakdown.totalLandedCost ?? (costBreakdown.metalCost + costBreakdown.diamondCost + costBreakdown.makingCost)).toFixed(2)}`, bold: true, dividerAfter: true },
                      { label: "Profit", value: `£${costBreakdown.profitAmount.toFixed(2)}` },
                      { label: "Sale Price", value: `£${costBreakdown.salePrice.toFixed(2)}`, bold: true },
                    ].map(({ label, value, muted, bold, dividerAfter }) => (
                      <div key={label}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "7px 0" }}>
                          <span style={{ fontSize: 12, color: muted ? "#aaa" : "#666", fontFamily: "Poppins, sans-serif" }}>{label}</span>
                          <span style={{ fontSize: 13, fontWeight: bold ? 600 : 400, color: bold ? "#111" : "#444", fontFamily: "Poppins, sans-serif" }}>{value}</span>
                        </div>
                        {dividerAfter && <div style={{ height: 1, background: "#e8c94e", margin: "2px 0" }} />}
                      </div>
                    ))}
                  </div>

                  {/* Two payment-type columns — Cash vs VAT, side-by-side. */}
                  <div style={{ marginTop: 16, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                    {[
                      {
                        label: "Cash Price",
                        sub: costBreakdown.cashMarkupPct > 0
                          ? `+£${Number(costBreakdown.cashMarkupAmount || 0).toFixed(2)} markup (${costBreakdown.cashMarkupPct}%)`
                          : "no markup",
                        value: costBreakdown.cashPrice ?? costBreakdown.clientPrice,
                        active: costBreakdown.viewerPaymentType === "cash",
                        suffix: "",
                      },
                      {
                        label: "VAT Price",
                        sub: "Sale price + VAT",
                        value: costBreakdown.vatPrice ?? costBreakdown.salePrice,
                        active: costBreakdown.viewerPaymentType !== "cash",
                        suffix: " + VAT",
                      },
                    ].map(({ label, sub, value, active, suffix }) => (
                      <div key={label} style={{
                        border: `1px solid ${active ? "#C5A028" : "#eadfac"}`,
                        background: active ? "rgba(197,160,40,0.08)" : "#fff",
                        padding: "12px 14px",
                        position: "relative",
                      }}>
                        {active && (
                          <span style={{ position: "absolute", top: -8, right: 10, background: "#C5A028", color: "#fff", fontSize: 8, fontWeight: 700, letterSpacing: 1, textTransform: "uppercase", padding: "2px 6px", fontFamily: "Poppins, sans-serif" }}>You</span>
                        )}
                        <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: 1.5, textTransform: "uppercase", color: "#C5A028", fontFamily: "Poppins, sans-serif" }}>{label}</div>
                        <div style={{ fontSize: 9, color: "#999", marginTop: 2, fontFamily: "Poppins, sans-serif" }}>{sub}</div>
                        <div style={{ fontSize: 18, fontWeight: 700, color: "#111", marginTop: 6, fontFamily: "Poppins, sans-serif" }}>
                          £{Number(value || 0).toFixed(2)}
                          {suffix && <span style={{ fontSize: 11, fontWeight: 600, color: "#888", marginLeft: 4 }}>{suffix}</span>}
                        </div>
                      </div>
                    ))}
                  </div>
                  {(costBreakdown.tradeDiscount > 0 || costBreakdown.badPayerSurcharge > 0) && (
                    <div style={{ fontSize: 10, color: "#888", marginTop: 10, fontStyle: "italic", fontFamily: "Poppins, sans-serif" }}>
                      Both prices include your account adjustments
                      {costBreakdown.tradeDiscount > 0 && ` (−${costBreakdown.tradeDiscount}% trade discount)`}
                      {costBreakdown.badPayerSurcharge > 0 && ` (+${costBreakdown.badPayerSurcharge}% surcharge)`}.
                    </div>
                  )}
                  </div>
                </div>
              )}

              <div className={styles.goldDivider} />

              {/* ── Configuration Panel ── */}

              {/* Engagement halo build — dedicated customer configurator (carat /
                 colour / clarity + accent quality, live price from the engine).
                 Metal + finger size default for now; engraving + actions stay below. */}
              {isHaloBuild && (
                <EngagementBuilder
                  product={productIdData}
                  onChange={handleEngagementChange}
                  applyRetailerPricing={applyRetailerPricing}
                  formatPrice={formatPrice}
                  qualityLabels={qualityLabels}
                  onShowSizeChart={() => setShowRingSizeModal(true)}
                  onColourImage={(path) => setSingleImg(path)}
                  // The chain step, rendered inside the builder so it lands between Size and
                  // Quality on this path too. Passed as a node rather than rebuilt there:
                  // the selection, the price and the cart line all live out here.
                  chainSlot={chainBlock}
                  // …and the enamelling beside it, for the same reason: the halo pendants are
                  // engagement builds, and without this they would show no control while their
                  // headline price and cart line already carried the charge.
                  enamelSlot={enamelBlock}
                  // …and the accent-quality cards quote a FULL price, so they have to carry
                  // the chain as well or they disagree with the headline above them.
                  addOnPrice={chainPrice + enamelPrice}
                />
              )}

              {/* Purity Selection */}
              {!isHaloBuild && (<>
              <div className={styles.configStep}>
                <span className={styles.stepLabel}>Select Metal Type</span>
                <div className={styles.variationGrid}>
                  {productIdData?.Variation?.map((item, index) => (
                    <div
                      key={index}
                      className={`${styles.variationCard} ${hightLight === index ? styles.activeVariation : ""}`}
                      onClick={() => {
                        setHighLight(index);
                        handleOnClickVariation(item);
                      }}
                    >
                      {item?.variationName}
                    </div>
                  ))}
                </div>
              </div>

              {/* Color Selection — product-level, hidden for Platinum/Silver */}
              {!/(platinum|silver)/i.test(variationData?.variationName || "") && (() => {
                const allColors = productIdData?.Variation?.flatMap(v => v.colors || []).filter(c => c.active !== false) || [];
                const uniqueColors = allColors.filter((c, i, arr) => arr.findIndex(x => x.color === c.color) === i);
                return uniqueColors.length > 0;
              })() && (
                <div className={styles.configStep}>
                  <span className={styles.stepLabel}>Select Colour</span>
                  <div className={styles.colorGrid}>
                    {(() => {
                      const allColors = productIdData?.Variation?.flatMap(v => v.colors || []).filter(c => c.active !== false) || [];
                      return allColors.filter((c, i, arr) => arr.findIndex(x => x.color === c.color) === i);
                    })().map((item, index) => {
                      const colourMap = {
                        "White Gold": { bg: "linear-gradient(135deg, #E8E8E8, #F5F5F5, #D8D8D8)", activeBg: "linear-gradient(135deg, #C0C0C0, #D8D8D8, #B0B0B0)", border: "#999", text: "#777", activeText: "#fff" },
                        "Yellow Gold": { bg: "linear-gradient(135deg, #F0D860, #F5E080, #E8C840)", activeBg: "linear-gradient(135deg, #B8922A, #C5A028, #A88520)", border: "#8B6914", text: "#9B7A20", activeText: "#fff" },
                        "Rose Gold": { bg: "linear-gradient(135deg, #F0C8B8, #F5D0C0, #E8B8A8)", activeBg: "linear-gradient(135deg, #C08878, #B87868, #A87060)", border: "#8B5E52", text: "#9A7068", activeText: "#fff" },
                        "Silver": { bg: "linear-gradient(135deg, #C8C8CE, #DDDDE2, #B8B8BE)", activeBg: "linear-gradient(135deg, #8E8E94, #A0A0A6, #767680)", border: "#5E5E66", text: "#5C5C64", activeText: "#fff" },
                        "Platinum": { bg: "linear-gradient(135deg, #E0E0E5, #F0F0F4, #D2D2D8)", activeBg: "linear-gradient(135deg, #9C9CA4, #B0B0B8, #888892)", border: "#5A5A62", text: "#5E5E66", activeText: "#fff" },
                      };
                      const cm = colourMap[item?.color] || { bg: "#f5f5f5", activeBg: "#333", border: "#333", text: "#555", activeText: "#fff" };
                      const isActive = selectedColor?.color === item?.color;
                      return (
                        <div
                          key={index}
                          className={styles.colorCard}
                          onClick={() => {
                            setPickedColor(item);
                            const colorImages = item?.images?.length > 0 ? item.images : productIdData?.Product_Images;
                            setSingleImg(colorImages?.[0]?.path);
                          }}
                          style={{
                            background: isActive ? cm.activeBg : cm.bg,
                            border: isActive ? `2px solid ${cm.border}` : "1px solid rgba(0,0,0,0.08)",
                            color: isActive ? cm.activeText : cm.text,
                            boxShadow: isActive ? "0 3px 10px rgba(0,0,0,0.2)" : "none",
                          }}
                        >
                          {isActive && (
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" style={{ position: "absolute", top: 5, left: 6, width: 11, height: 11 }}>
                              <polyline points="20 6 9 17 4 12" />
                            </svg>
                          )}
                          {item?.color}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {/* Size Selection — hidden when there is nothing to choose */}
              {hasChoosableSize && (
              <div className={styles.configStep}>
                <div className={styles.stepLabelRow}>
                  <span className={styles.stepLabel}>Select Size</span>
                  {isRingProduct && (
                    <button
                      type="button"
                      className={styles.ringSizeLink}
                      onClick={() => setShowRingSizeModal(true)}
                    >
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="14" height="14">
                        <circle cx="12" cy="12" r="10" />
                        <line x1="12" y1="16" x2="12" y2="12" />
                        <line x1="12" y1="8" x2="12.01" y2="8" />
                      </svg>
                      Ring Size Conversion Chart
                    </button>
                  )}
                </div>
                {variationSizes?.length > 10 ? (
                  <Select
                    value={sizeName}
                    onChange={(value) => {
                      const selected = variationSizes.find((s) => s.sizeLabel === value);
                      if (selected) handleSize(selected);
                    }}
                    placeholder="Choose a size"
                    className={styles.sizeDropdown}
                    popupClassName={styles.sizeDropdownPopup}
                    options={variationSizes.map((itm) => ({
                      value: itm.sizeLabel,
                      label: itm.sizeLabel,
                    }))}
                  />
                ) : (
                  <div className={styles.sizeGrid}>
                    {variationSizes?.map((itm, index) => (
                      <button
                        key={index}
                        type="button"
                        onClick={() => handleSize(itm)}
                        className={`${styles.sizePill} ${sizeName === itm.sizeLabel ? styles.activeSize : ""}`}
                      >
                        {itm.sizeLabel}
                      </button>
                    ))}
                  </div>
                )}
              </div>
              )}

              {/* Chain — a pendant is priced on the pendant's gold alone, so the chain is
                 its own line, charged at what the supplier charges us. It sits here, between
                 Size and Quality, for two reasons: it is a physical choice like size rather
                 than a money one, and the quality cards below quote a full price — putting
                 the chain after them would leave those figures disagreeing with the headline.
                 Absent entirely unless the piece offers a chain AND the builder has a weight
                 for the metal on screen. */}
              {chainBlock}

              {/* Picture enamelling — a workshop service rather than a variant, so it sits with
                 the chain: both are add-ons to the finished piece and both are charged at a
                 flat rate outside the retailer pricing. Absent entirely unless the piece
                 offers it. */}
              {enamelBlock}

              {/* Engagement-ring centre diamond — labelled like the other
                 variant steps; button -> modal -> result. Sits above Select
                 Quality. Guarded by productType so other products are untouched. */}
              {productIdData?.productType === "engagement-ring" && (
                <div className={styles.configStep}>
                  <span className={styles.stepLabel}>Centre Diamond</span>
                  {/* Hand it a starting stone. Pre-selection inside the component is
                      opt-in via initialSelection (see EngagementCentreStone ~L122:
                      it bails when there is no initialSelection.carat), so without
                      this a pendant showed an empty "choose a diamond" prompt while
                      the engagement builder — which does pass it, ~L282 — showed a
                      chosen stone with a CHANGE button. Same stone the modal would
                      open on: smallest carat offered, and the colour and clarity the
                      admin saved first. Rebuilt each render is fine; the component
                      guards with didInit so it only applies once, and the customer
                      can still Change or clear it. */}
                  <EngagementCentreStone
                    centreStone={productIdData.centreStone}
                    initialSelection={cheapestCentre}
                    onChange={handleCentreStoneChange}
                  />
                </div>
              )}

              {/* Diamond Quality Selection */}
              {currentDiamondComponents.length > 0 && (
                <div className={styles.configStep}>
                  <span className={styles.stepLabel}>
                    {productIdData?.centreStone?.enabled
                      ? "Select Diamond Quality for Accent/Side Stones"
                      : "Select Quality"}
                  </span>
                  <div className={styles.qualityGrid}>
                    {qualityColumns.filter(q => currentTotals[q.key] > 0).map((q) => (
                      <button
                        type="button"
                        key={q.key}
                        onClick={() => {
                          setSelectedQuality(q.key);
                          setSelectedDiamondSizeId(
                            currentSize?.diamondSizes?.[0]?._id || null,
                          );
                          setFinalPrice(
                            currentMetalPrice + (currentTotals[q.key] || 0) + getCentreStonePrice(q.key, selectedCentreStone),
                          );
                        }}
                        className={`${styles.qualityCard} ${
                          selectedQuality === q.key ? styles.activeQuality : ""
                        }`}
                      >
                        <div className={styles.qualityLabel}>{q.label}</div>
                        {/* A quality card quotes a FULL price, so it carries the chain too \u2014
                            otherwise the card the customer clicks and the headline above it
                            show two different numbers. */}
                        <div className={styles.qualityPrice}>
                          {"\u00A3"}{formatPrice(withAddOns(currentMetalPrice + (currentTotals[q.key] || 0) + getCentreStonePrice(q.key, selectedCentreStone)))}
                        </div>
                      </button>
                    ))}
                  </div>
                </div>
              )}

              {/* Centre Stone Selector */}
              {productIdData?.centreStone?.enabled && productIdData.centreStone.options?.length > 0 && selectedQuality && (
                <div style={{ marginBottom: 20 }}>
                  <div style={{ fontSize: 11, fontWeight: 600, letterSpacing: 1, textTransform: "uppercase", color: "#999", marginBottom: 8 }}>
                    Centre Stone — {productIdData.centreStone.shape}
                  </div>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                    {productIdData.centreStone.options
                      .filter(opt => {
                        // Only show options where the selected quality is active
                        const normKey = (selectedQuality || "").toLowerCase().replace(/[^a-z0-9]+/g, "_");
                        const overrides = opt.qualityOverrides || {};
                        if (overrides[normKey] === false) return false;
                        // Must have a price for this quality
                        const qv = opt.qualityVariants?.find(q => (q.quality || "").toLowerCase().replace(/[^a-z0-9]+/g, "_") === normKey);
                        const single = opt.qualityVariants?.find(q => (q.quality || "").toLowerCase().replace(/[^a-z0-9]+/g, "_") === "single");
                        return (qv?.finalPrice || single?.finalPrice || 0) > 0;
                      })
                      .map(opt => {
                        const csPrice = getCentreStonePrice(selectedQuality, opt);
                        const isSelected = selectedCentreStone?.carat === opt.carat;
                        return (
                          <button
                            key={opt.carat}
                            type="button"
                            onClick={() => {
                              setSelectedCentreStone({ carat: opt.carat, label: opt.label });
                              setFinalPrice(currentMetalPrice + (currentTotals[selectedQuality] || 0) + csPrice);
                            }}
                            style={{
                              padding: "10px 16px", border: isSelected ? "2px solid #C5A028" : "1px solid #e0e0e0",
                              background: isSelected ? "rgba(197,160,40,0.06)" : "#fff", cursor: "pointer",
                              fontFamily: "Poppins,sans-serif", textAlign: "center", minWidth: 80, transition: "all 0.15s",
                            }}
                          >
                            <div style={{ fontSize: 13, fontWeight: 700, color: "#111", marginBottom: 2 }}>{opt.label || `${opt.carat}ct`}</div>
                            <div style={{ fontSize: 11, color: isSelected ? "#C5A028" : "#888" }}>
                              +{"\u00A3"}{formatPrice(applyRetailerPricing(csPrice))}
                            </div>
                          </button>
                        );
                      })}
                  </div>
                </div>
              )}
              </>)}

              {/* Engraving Section */}
              {productIdData?.Engraving_Available && (
                <div style={{ marginBottom: 20 }}>
                  <div style={{ fontSize: 11, fontWeight: 600, letterSpacing: 1, textTransform: "uppercase", color: "#999", marginBottom: 8 }}>
                    Engraving (Optional)
                  </div>
                  <div style={{ position: "relative" }}>
                    <input
                      type="text"
                      value={engravingText}
                      onChange={(e) => { if (e.target.value.length <= 30) setEngravingText(e.target.value); }}
                      placeholder="Enter engraving text..."
                      maxLength={30}
                      style={{
                        width: "100%",
                        height: 44,
                        border: engravingText ? "1.5px solid #C5A028" : "1px solid #e8e8e8",
                        padding: "0 40px 0 14px",
                        fontSize: 14,
                        fontFamily: "Poppins, sans-serif",
                        color: "#333",
                        outline: "none",
                        boxSizing: "border-box",
                        borderRadius: 0,
                        transition: "border-color 0.2s",
                      }}
                    />
                    <button
                      type="button"
                      onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                      style={{
                        position: "absolute",
                        right: 8,
                        top: "50%",
                        transform: "translateY(-50%)",
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        padding: 4,
                        lineHeight: 1,
                        display: "flex",
                        alignItems: "center",
                      }}
                      title="Add symbol"
                    >
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
                    </button>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", marginTop: 4 }}>
                    <span style={{ fontSize: 11, color: "#bbb" }}>Max 30 characters</span>
                    <span style={{ fontSize: 11, color: engravingText.length >= 28 ? "#e74c3c" : "#bbb" }}>{engravingText.length}/30</span>
                  </div>
                  {showEmojiPicker && (
                    <div style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 0,
                      marginTop: 8,
                      border: "1px solid #eee",
                      background: "#fafafa",
                    }}>
                      {[
                        { char: "♥", label: "Heart" },
                        { char: "♡", label: "Open Heart" },
                        { char: "∞", label: "Infinity" },
                        { char: "◇", label: "Diamond" },
                        { char: "★", label: "Star" },
                        { char: "☆", label: "Open Star" },
                        { char: "✦", label: "4-Star" },
                        { char: "✝", label: "Cross" },
                        { char: "☽", label: "Moon" },
                        { char: "☀", label: "Sun" },
                        { char: "♛", label: "Crown" },
                        { char: "⚓", label: "Anchor" },
                        { char: "♪", label: "Music" },
                        { char: "✿", label: "Flower" },
                        { char: "→", label: "Arrow" },
                        { char: "↔", label: "Double Arrow" },
                        { char: "☮", label: "Peace" },
                        { char: "⚘", label: "Rose" },
                        { char: "&", label: "Ampersand" },
                        { char: "•", label: "Dot" },
                      ].map((item) => (
                        <button
                          key={item.char}
                          type="button"
                          onClick={() => {
                            if (engravingText.length < 29) {
                              setEngravingText(engravingText + item.char);
                            }
                            setShowEmojiPicker(false);
                          }}
                          title={item.label}
                          style={{
                            width: 44,
                            height: 44,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 16,
                            background: "none",
                            border: "none",
                            borderRight: "1px solid #f0f0f0",
                            borderBottom: "1px solid #f0f0f0",
                            cursor: "pointer",
                            color: "#333",
                            transition: "all 0.15s",
                          }}
                          onMouseEnter={(e) => { e.target.style.background = "#fff"; e.target.style.color = "#C5A028"; }}
                          onMouseLeave={(e) => { e.target.style.background = "none"; e.target.style.color = "#333"; }}
                        >
                          {item.char}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              )}

              <div className={styles.goldDivider} />

              {/* Action Area */}
              {!userToken ? (
                <Button
                  type="primary"
                  size="large"
                  block
                  onClick={home}
                  className={styles.loginBtn}
                >
                  LOGIN TO PURCHASE
                </Button>
              ) : (
                <div className={styles.actionRow}>
                  <div className={styles.quantitySelector}>
                    <button type="button" onClick={Decree}>-</button>
                    <span className={styles.qtyDisplay}>{qty}</span>
                    <button type="button" onClick={Incree}>+</button>
                  </div>
                  <Button
                    type="primary"
                    icon={<ShoppingCartOutlined />}
                    size="large"
                    onClick={addCart}
                    loading={loader}
                    className={styles.addToCartBtn}
                  >
                    ADD TO CART
                  </Button>
                  <button
                    type="button"
                    onClick={() => setShowCustomiseModal(true)}
                    className={styles.customiseBtn}
                  >
                    <CustomiseIcon />
                    CUSTOMISE
                  </button>
                  <button
                    type="button"
                    onClick={() => setShowShareModal(true)}
                    className={styles.quoteClientBtn}
                  >
                    <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18" aria-hidden="true">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                    </svg>
                    QUOTE YOUR CLIENT
                  </button>
                </div>
              )}

              {/* WhatsApp enquiry prompt */}
              <div className={styles.enquiryPrompt}>
                <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                </svg>
                <span>Have a question? <a href={buildWhatsAppUrl()} target="_blank" rel="noopener noreferrer">Chat with us on WhatsApp</a></span>
              </div>

              {/* B2B extensibility placeholder */}
              <div className={styles.b2bActions} />
            </div>
          </div>

          {/* ═══ HIGHLIGHTS STRIP ═══ */}
          <div className={`${styles.highlightsStrip} ${styles.highlightsDesktop}`}>
            {[
              { icon: <><path d="M12 2L2 7l10 5 10-5-10-5z" /><path d="M2 17l10 5 10-5" /><path d="M2 12l10 5 10-5" /></>, title: "IGI Certified*", desc: "Independently graded" },
              { icon: <><path d="M7 20V9a5 5 0 0 1 10 0" /><line x1="5" y1="12" x2="16" y2="12" /><line x1="5" y1="16" x2="16" y2="16" /><line x1="7" y1="20" x2="18" y2="20" /></>, title: "Trade Pricing", desc: "Exclusive B2B rates" },
              { icon: <><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></>, title: "Made to Order", desc: "Bespoke craftsmanship" },
              { icon: <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />, title: "NAJ Member", desc: "Trusted & verified" },
            ].map((item, i) => (
              <div key={i} className={styles.highlightItem}>
                <div className={styles.highlightIcon}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    {item.icon}
                  </svg>
                </div>
                <div className={styles.highlightTitle}>{item.title}</div>
                <div className={styles.highlightDesc}>{item.desc}</div>
              </div>
            ))}
          </div>

          {/* ═══ SECTION DIVIDER ═══ */}
          <div className={styles.sectionDivider} />

          {/* ═══ DETAILS SECTION ═══ */}
          <div className={styles.detailsSection}>
            <div className={styles.sectionHeading}>
              <span className={styles.sectionEyebrow}>Everything You Need To Know</span>
              <h2 className={styles.sectionTitle}>Product Details</h2>
              <div className={styles.sectionLine} />
            </div>

            {/* Desktop: Tabs */}
            <div className={styles.desktopOnly}>
              <Tabs
                defaultActiveKey="1"
                items={productTabs}
                centered
                className={styles.customTabs}
              />
            </div>

            {/* Mobile: Collapse */}
            <div className={styles.mobileOnly}>
              <Collapse
                bordered={false}
                defaultActiveKey={["1"]}
                expandIconPosition="end"
                className={styles.detailsCollapse}
                items={productTabs.map((tab) => ({
                  key: tab.key,
                  label: tab.label,
                  children: tab.children,
                }))}
              />
            </div>
          </div>

          {/* ═══ HIGHLIGHTS STRIP (mobile position) ═══ */}
          <div className={`${styles.highlightsStrip} ${styles.highlightsMobile}`}>
            {[
              { icon: <><path d="M12 2L2 7l10 5 10-5-10-5z" /><path d="M2 17l10 5 10-5" /><path d="M2 12l10 5 10-5" /></>, title: "IGI Certified*", desc: "Independently graded" },
              { icon: <><path d="M7 20V9a5 5 0 0 1 10 0" /><line x1="5" y1="12" x2="16" y2="12" /><line x1="5" y1="16" x2="16" y2="16" /><line x1="7" y1="20" x2="18" y2="20" /></>, title: "Trade Pricing", desc: "Exclusive B2B rates" },
              { icon: <><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></>, title: "Made to Order", desc: "Bespoke craftsmanship" },
              { icon: <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />, title: "NAJ Member", desc: "Trusted & verified" },
            ].map((item, i) => (
              <div key={i} className={styles.highlightItem}>
                <div className={styles.highlightIcon}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    {item.icon}
                  </svg>
                </div>
                <div className={styles.highlightTitle}>{item.title}</div>
                <div className={styles.highlightDesc}>{item.desc}</div>
              </div>
            ))}
          </div>

          {/* ═══ COMPLETE THE SET ═══
              Sits above Shop The Brand because it is the more specific
              suggestion: these are the pieces that pair with this one, not
              simply more of the same maker. */}
          {relatedProducts.length > 0 && (
            <>
              <div className={styles.sectionDivider} />
              <div className={styles.recommendationsSection}>
                <div className={styles.sectionHeading}>
                  <span className={styles.sectionEyebrow}>
                    {relatedHasSet ? "Made To Be Worn Together" : "More Like This"}
                  </span>
                  <h2 className={styles.sectionTitle}>
                    {relatedHasSet ? "Complete The Set" : "You May Also Like"}
                  </h2>
                  <div className={styles.sectionLine} />
                </div>
                <Slider {...getCarouselSettings(relatedProducts.length)}>
                  {relatedProducts.map((item, index) => (
                    <div key={item._id || index} className={styles.slideItem}>
                      <ProductCard item={item} />
                    </div>
                  ))}
                </Slider>
              </div>
            </>
          )}

          {/* ═══ SHOP THE BRAND ═══ */}
          {sameBrandProducts.length > 0 && (
            <>
              <div className={styles.sectionDivider} />
              <div className={styles.recommendationsSection}>
                <div className={styles.sectionHeading}>
                  <span className={styles.sectionEyebrow}>
                    More From {productIdData?.Brand?.Brand_Name}
                  </span>
                  <h2 className={styles.sectionTitle}>Shop The Brand</h2>
                  <div className={styles.sectionLine} />
                </div>
                <Slider {...getCarouselSettings(sameBrandProducts.length)}>
                  {sameBrandProducts.map((item, index) => (
                    <div key={index} className={styles.slideItem}>
                      <ProductCard item={item} />
                    </div>
                  ))}
                </Slider>
              </div>
            </>
          )}

          {/* ═══ MORE IN THIS CATEGORY ═══ */}
          {sameCategoryProducts.length > 0 && (
            <>
              <div className={styles.sectionDivider} />
              <div className={styles.recommendationsSection}>
                <div className={styles.sectionHeading}>
                  <span className={styles.sectionEyebrow}>
                    Explore {productCategory}
                  </span>
                  <h2 className={styles.sectionTitle}>More In This Category</h2>
                  <div className={styles.sectionLine} />
                </div>
                <Slider {...getCarouselSettings(sameCategoryProducts.length)}>
                  {sameCategoryProducts.map((item, index) => (
                    <div key={index} className={styles.slideItem}>
                      <ProductCard item={item} />
                    </div>
                  ))}
                </Slider>
              </div>
            </>
          )}

          {/* ═══ RING SIZE MODAL ═══ */}
          <RingSizeChartModal
            open={showRingSizeModal}
            onClose={() => { setShowRingSizeModal(false); }}
          />

          {/* Picture-enamelling explainer — opened by the (i) beside the option.
             The lead is what the customer gets; the water limit is a point-of-sale
             disclosure and is spelled out rather than softened, because someone who
             wears a locket in the shower has to have been told here and not after. */}
          <Modal
            open={showEnamelInfo}
            onCancel={() => setShowEnamelInfo(false)}
            footer={null}
            width={520}
            closable
            destroyOnClose
            centered
          >
            <div style={{ padding: "4px 4px 8px" }}>
              <div style={{ fontSize: 11, fontWeight: 600, letterSpacing: 1, textTransform: "uppercase", color: "#C5A028", marginBottom: 6 }}>
                Add-on
              </div>
              <h3 style={{ fontSize: 20, fontWeight: 600, color: "#111", margin: "0 0 10px" }}>
                {PICTURE_ENAMELLING_LABEL}
              </h3>
              <p style={{ fontSize: 14, color: "#555", lineHeight: 1.7, margin: "0 0 18px" }}>
                {PICTURE_ENAMELLING_INTRO}
              </p>
              <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                {PICTURE_ENAMELLING_POINTS.map((pt) => (
                  <div key={pt.title}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: "#111", marginBottom: 3 }}>
                      {pt.title}
                    </div>
                    <div style={{ fontSize: 13, color: "#666", lineHeight: 1.65 }}>
                      {pt.body}
                    </div>
                  </div>
                ))}
              </div>
              {enamelCfg && (
                <div style={{ marginTop: 18, paddingTop: 14, borderTop: "1px solid #eee", fontSize: 13, color: "#111" }}>
                  <strong style={{ fontWeight: 600 }}>
                    {"£"}{formatPrice(Number(enamelCfg.gbp || 0))}
                  </strong>
                  <span style={{ color: "#888" }}>
                    {" "}added to the price of the piece. We&rsquo;ll be in touch for your photograph once the order is placed.
                  </span>
                </div>
              )}
            </div>
          </Modal>

          {/* Customisation request modal */}
          <Modal
            open={showCustomiseModal}
            onCancel={() => { if (!customiseSending) { setShowCustomiseModal(false); setCustomiseMessage(""); } }}
            footer={null}
            width={520}
            closable
            destroyOnClose
            className={styles.customiseModal}
            centered
          >
            <div className={styles.customiseModalBody}>
              <div className={styles.customiseEyebrow}>Bespoke</div>
              <h3 className={styles.customiseTitle}>Customise this piece</h3>
              <p className={styles.customiseLead}>
                Tell us what you'd like changed — metal, stones, engraving,
                size, finish — and our team will get back to you with options.
              </p>

              <label className={styles.customiseLabel} htmlFor="customise-message">
                Describe your customisation
              </label>
              <textarea
                id="customise-message"
                className={styles.customiseTextarea}
                placeholder="e.g. I'd like this in 18K rose gold, with a 0.50ct round centre stone and the inside engraved with 'A&J 09.06.2026'."
                value={customiseMessage}
                onChange={(e) => setCustomiseMessage(e.target.value)}
                rows={6}
                maxLength={2000}
                disabled={customiseSending}
              />
              <div className={styles.customiseCounter}>
                {customiseMessage.length}/2000
              </div>

              <div className={styles.customiseActions}>
                <button
                  type="button"
                  className={styles.customiseCancel}
                  onClick={() => { setShowCustomiseModal(false); setCustomiseMessage(""); }}
                  disabled={customiseSending}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className={styles.customiseSubmit}
                  onClick={submitCustomisation}
                  disabled={customiseSending || !customiseMessage.trim()}
                >
                  {customiseSending ? "Sending…" : "Send request"}
                </button>
              </div>
            </div>
          </Modal>

          {/* Share-to-WhatsApp modal */}
          <Modal
            open={showShareModal}
            onCancel={() => { if (!shareSending) setShowShareModal(false); }}
            footer={null}
            width={820}
            closable
            destroyOnClose
            className={styles.shareModal}
            centered
          >
            {(() => {
              const fields = getShareFields();
              const summaryLabels = [
                "Image",
                shareIncludeSku && productIdData?.SKU_Code ? "SKU" : null,
                ...fields.filter((f) => shareFieldToggles[f.key]).map((f) => f.label),
              ].filter(Boolean);
              const messageText = buildShareMessage();
              const renderLine = (s) => {
                if (!s) return " ";
                let html = s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
                html = html.replace(/\*([^*\n]+)\*/g, "<strong>$1</strong>");
                html = html.replace(/_([^_\n]+)_/g, "<em>$1</em>");
                return html;
              };
              return (
                <div className={styles.shareBody}>
                  <div className={styles.shareHeader}>
                    <h3 className={styles.shareHeaderTitle}>Share to WhatsApp</h3>
                  </div>

                  <div className={styles.shareLayout}>
                    <div className={styles.shareLeft}>
                      <div className={styles.shareSectionTitle}>Shared details</div>
                      <div className={styles.shareSummary}>
                        {summaryLabels.join(" · ")}
                      </div>
                      <button
                        type="button"
                        className={styles.shareCustomiseBtn}
                        onClick={() => setShareCustomiseOpen((v) => !v)}
                      >
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16" aria-hidden="true">
                          <line x1="4" y1="6" x2="14" y2="6" />
                          <circle cx="17" cy="6" r="2" />
                          <line x1="4" y1="12" x2="8" y2="12" />
                          <circle cx="11" cy="12" r="2" />
                          <line x1="14" y1="12" x2="20" y2="12" />
                          <line x1="4" y1="18" x2="16" y2="18" />
                          <circle cx="19" cy="18" r="2" />
                        </svg>
                        Customise details to share
                      </button>
                      {shareCustomiseOpen && (
                        <div className={styles.shareCustomisePane}>
                          {productIdData?.SKU_Code && (
                            <label className={styles.shareCheckRow}>
                              <input
                                type="checkbox"
                                checked={shareIncludeSku}
                                onChange={(e) => setShareIncludeSku(e.target.checked)}
                              />
                              <span><strong>SKU</strong> — {productIdData.SKU_Code}</span>
                            </label>
                          )}
                          {fields.map((f) => (
                            <label key={f.key} className={styles.shareCheckRow}>
                              <input
                                type="checkbox"
                                checked={!!shareFieldToggles[f.key]}
                                onChange={(e) =>
                                  setShareFieldToggles((prev) => ({
                                    ...prev,
                                    [f.key]: e.target.checked,
                                  }))
                                }
                              />
                              <span><strong>{f.label}</strong> — {f.value}</span>
                            </label>
                          ))}
                        </div>
                      )}

                      <div className={styles.shareSectionTitle} style={{ marginTop: 28 }}>
                        Shared price
                      </div>
                      <label className={styles.shareToggleRow}>
                        <input
                          type="checkbox"
                          className={styles.shareSwitch}
                          checked={shareIncludePrice}
                          onChange={(e) => setShareIncludePrice(e.target.checked)}
                        />
                        <span>Include price in message</span>
                      </label>

                      {shareIncludePrice && (
                        <>
                          <div className={styles.shareInputRow}>
                            <div className={styles.shareInputCol}>
                              <div className={styles.shareInputLabelRow}>
                                <label className={styles.shareInputLabel}>Markup</label>
                                <div className={styles.shareMarkupModeToggle}>
                                  <button
                                    type="button"
                                    className={shareMarkupMode === "pct" ? styles.shareModeActive : ""}
                                    onClick={() => setShareMarkupMode("pct")}
                                  >
                                    %
                                  </button>
                                  <button
                                    type="button"
                                    className={shareMarkupMode === "amount" ? styles.shareModeActive : ""}
                                    onClick={() => setShareMarkupMode("amount")}
                                  >
                                    £
                                  </button>
                                </div>
                              </div>
                              <div className={styles.shareInputWrap}>
                                {shareMarkupMode === "pct" ? (
                                  <>
                                    <input
                                      type="number"
                                      value={shareMarkupPct}
                                      onChange={(e) => setShareMarkupPct(e.target.value)}
                                      min={0}
                                      step={1}
                                    />
                                    <span className={styles.shareInputSuffix}>%</span>
                                  </>
                                ) : (
                                  <>
                                    <span className={styles.shareInputPrefix}>£</span>
                                    <input
                                      type="number"
                                      className={styles.shareInputPrefixed}
                                      value={shareMarkupAmount}
                                      onChange={(e) => setShareMarkupAmount(e.target.value)}
                                      min={0}
                                      step="0.01"
                                    />
                                  </>
                                )}
                              </div>
                              <div className={styles.shareMarkupDelta}>
                                + £{formatPrice(computeMarkupDelta())} markup
                              </div>
                            </div>
                            <div className={styles.shareInputCol}>
                              <label className={styles.shareInputLabel}>Final price</label>
                              <div className={styles.shareInputWrap}>
                                <input
                                  type="text"
                                  value={`GBP${formatPrice(computeSharedPrice())}`}
                                  readOnly
                                />
                              </div>
                            </div>
                          </div>

                          <label className={styles.shareToggleRow}>
                            <input
                              type="checkbox"
                              className={styles.shareSwitch}
                              checked={sharePlusVAT}
                              onChange={(e) => setSharePlusVAT(e.target.checked)}
                            />
                            <span>Include VAT (20%)</span>
                          </label>

                          <div className={styles.shareFinalPrice}>
                            <strong>£{formatPrice(computeSharedPrice())}</strong>
                            <span> Final shared price</span>
                          </div>
                          {!sharePlusVAT && (
                            <div className={styles.shareVatNote}>
                              * Price shared is exclusive of VAT
                            </div>
                          )}
                        </>
                      )}
                    </div>

                    <div className={styles.shareRight}>
                      <div className={styles.sharePreviewPill}>Preview message</div>
                      <div className={styles.sharePreviewBubble}>
                        {singleImg && (
                          <div className={styles.sharePreviewImage}>
                            <img src={`${BASE_URL}/${singleImg}`} alt="" />
                          </div>
                        )}
                        <div className={styles.sharePreviewText}>
                          {messageText.split("\n").map((line, i) => (
                            <div
                              key={i}
                              className={line === "" ? styles.sharePreviewBlank : styles.sharePreviewLine}
                              dangerouslySetInnerHTML={{ __html: renderLine(line) }}
                            />
                          ))}
                          <div className={styles.sharePreviewTime}>
                            {new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}
                            <span className={styles.sharePreviewTicks}>✓✓</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={styles.shareFooter}>
                    {!isMobileDevice() && (
                      <div className={styles.shareDesktopHint}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16" aria-hidden="true">
                          <circle cx="12" cy="12" r="10" />
                          <line x1="12" y1="8" x2="12" y2="12" />
                          <circle cx="12" cy="16" r="0.5" fill="currentColor" />
                        </svg>
                        <span>
                          On desktop, the image is copied to your clipboard.
                          After picking a contact in WhatsApp, press <kbd>Ctrl</kbd> + <kbd>V</kbd> to paste it alongside the message.
                        </span>
                      </div>
                    )}
                    <button
                      type="button"
                      className={styles.shareSubmit}
                      onClick={handleShareToWhatsApp}
                      disabled={shareSending}
                    >
                      {shareSending ? "Sharing…" : (
                        <>Share to WhatsApp <span aria-hidden="true">→</span></>
                      )}
                    </button>
                    <p className={styles.shareFooterNote}>
                      This action will open WhatsApp, where you can further edit your message.
                    </p>
                  </div>
                </div>
              );
            })()}
          </Modal>

          {/* ═══ MOBILE STICKY BAR ═══ */}
          {userToken && (
            <div className={styles.mobileStickyBar}>
              <div className={styles.stickyPrice}>
                <div className={styles.stickyPriceLabel}>Total</div>
                <div className={styles.stickyPriceValue}>
                  {showFromPrice ? "From " : ""}{"\u00A3"}{formatPrice(withAddOns(finalPrice))}
                </div>
              </div>
              <button
                type="button"
                className={styles.stickyCartBtn}
                onClick={addCart}
              >
                ADD TO CART
              </button>
            </div>
          )}
        </div>
      )}
    </div>
    </div>
  );
}

export default AddCart;
